import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewChildren, ElementRef, QueryList, HostListener, ChangeDetectorRef, Renderer2 } from "@angular/core";
import { ItineraryService } from "../../itinerary.service";
import { RestService } from "../../rest.service";
import { ResponseSearhDetailsReservation } from "./ResponseSearchDetailsReservation";
import { CookieService } from "ngx-cookie";
import { MatDialog } from "@angular/material/dialog";
import { UserService } from "../../../pages/com.usblick.common/auth/user.service";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import CssFilterConverter from "css-filter-converter";
import { title } from "process";
import { setting } from "../../../../../setting";
import { HttpErrorResponse } from "@angular/common/http";
import { isValidOwener } from "../../../utils/Functions";
import { DynamicFontSizePipe } from "app/shared/dynamic-font-size.pipe";
import { MatSelect } from "@angular/material/select";
import { ProductFactoryService } from "services/itinerary/products/product-factory.service";
import { IProductCreationParams } from "model/product.interface";
import { IExperiencieProduct } from "model/experience-product.interface";
import { CurrencyConverterPurePipe } from "app/shared/currency-converter-pure.pipe";
import { getCommentadjective } from "app/content-result/category-result/result/base-result/information/categories/hotel-result/hotel-result-funtions";
import { flagByLanguageNameExperience } from "app/content-result/category-result/result/base-result/information/categories/activities-result/activities-result-function";
import { NotificationService } from "app/shared/notifications/notification.service";
moment.locale('es');

@Component({
  selector: "usb-modal-tours",
  templateUrl: "./modal-tours.component.html",
  styleUrls: ["./modal-tours.component.scss"],
  providers: [DynamicFontSizePipe, CurrencyConverterPurePipe],
})
export class ModalToursComponent implements OnInit {
  @Input() tour: any;
  @Input() payloadUpdate: any;
  @Input() origin?: any;
  @Input() arrayResults?: any;
  @Input() itineraryItem?: any;
  @Input() form: any;
  @Input() tabActive: any;
  @Input() clientSetting: any;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() paymentAgencyActive: any;
  @Input() _payload: any;
  @Input() payload: any;
  @Input() component: string;
  @Input() quote: boolean = true;
  @Input() action: string = '';
  @Input() openInfoDescription: boolean = false;
  @Input() from: string = '';
  @ViewChild("gmap") gmapElement: any;
  @ViewChild('passengerContainer') passengerContainer!: ElementRef;
  @ViewChild('collapseElement') collapseElement: any;
  @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;
  @ViewChild('mySelect') mySelect: MatSelect;
  @ViewChild('mySelectHour') mySelectHour: ElementRef;
  @ViewChild('mySelectLanguage') mySelectLanguage: ElementRef;
  @Output() refModal = new EventEmitter<any>();

  _select: any;
  _disabledButton: boolean;
  _itemOption: any;
  _findData: boolean;
  _total: number;
  _itemSelected: ResponseSearhDetailsReservation = {
    availableDate: undefined,
    questions: [],
  };
  _loadDates = false;
  _selectDate = "Select date...";
  notFoundDates: boolean;
  toursAvailableDates: any = [];
  dateAvailablesReady: boolean = false;
  dateSelected: boolean = false;
  dayInitPayload: string;
  dayFinalPayload: string;
  companyNamesOpt: string[] = [];
  itemsTour: any[] = [];

  optionsTour: any[] = [];
  selectTour: any;
  arrayDatesAvailables: any[] = [];
  dateLastFrom: string = "";
  dateLastTo: string = "";
  totalProfValues: number = 0;
  toggle = false;
  status = "Enable";
  dateSelect: string = "";
  infoArr: string[] = [];
  adultsTotalPrice: number = 0;
  childsPriceFrom: number = 0;
  childsPriceTo: number = 0;
  titleSelectUniqueHotel: string = "";
  totalPriceTransfer: number;
  textInfoExtra: string = "";
  arrayPricesPassengers: any[] = [];
  currencySelected: string = "";
  agency: any;
  confirmTransfer: any;
  typeTranfer: any;
  backgroundSelect: any;
  buttonColorActive: any;
  buttonTextActive: any;
  disabledOption: boolean = false;
  transferTypeSelected: string = "";
  arrayHotelsItinerary: any[] = [];
  valuePriceTypeTransfer: number;
  transferTypeValue: string | null = null;
  continueValidProcess: boolean = true;
  indexPaxMandatory: number = -1;
  private observer!: MutationObserver;
  coordinatesArr: any[] = [];
  calendarDays: any[] = [];

  /** Per-option cronograma state, keyed by option identifier */
  private _cronogramaStateByOption: Map<string | number, {
    stopsRoute: any[];
    selectedRouteIndex: number;
    routeVisible: boolean;
  }> = new Map();

  private _getCronogramaKey(option: any, optionIndex: number): string | number {
    return option?.optionId ?? optionIndex;
  }

  /** Control para mostrar tooltip de eliminación */
  showDeleteTooltip: boolean[] = [];

  now = new Date();
  currentTime = this.now.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  requireTransfer: boolean = false;
  typeTransfer: string;
  validate = false;
  _close = false;
  comments: any[] = [];
  validateImages:boolean = false;


  tab: string = "tour";

  daysMissing: any[] = [];
  selectedTransfer: any;
  currentYear: number;
  currentMonth: number;

  passengers: string = "Seleccione los pasajeros";
  hours: string = "Seleccione el horario";

  hourSelectHidden: boolean = false;
  adultsCount: number = 1;
  childrenCount: number = 0;
  // Contadores hardcodeados para las cards "Ticket de Ingreso" y "Tour Relacionado"
  // (sección "Completa tu viaje"). Cuando el backend devuelva el array de servicios,
  // esto migra a un mapa tipo addonsQuantities (ver más abajo).
  ticketQty: { [optionId: string]: number } = {};
  tourRelatedQty: { [optionId: string]: number } = {};
  hoursAvailable: any[] = [];
  languageGuideAvailable: any[] = [];
  paxAdultsAgeArr: any [] = [];
  paxChildsAgesArr: any[] = [];
  isCollapsed: boolean = false;
  isCollapsedAdult: boolean = false;
  isCollapsedChild: boolean = false;
  isCollapsedCheckInReq: boolean = true;
  isCollapsedCheckInObs: boolean = true;
  _routeSelected: any[];
  fontSizeAdjustments = { 6: 0, 9: -2, 12: -4 };
  passengerCounts: number[] = [];
  hourSelected: string;
  totalPassengers: number;
  languageSelected: string;
  cancellationPoliciesDateSelected: any[] = [];
  childAges: number[] = [];
  isTransferSelect: boolean = false;
  createNewPaxSelectedTicket: boolean = true;
  pickupLocation: any;
  routeUpdate: any;
  othersProductsToursItinerary: any[] = [];
  styleBookingFlow: any;
  coordinatesSelected: any;
  selectedStop: any = null;


    assesmentComments = Array.from({ length: 5 }, (_, i) => i);

  //ticket
  ticketsSelected: any[] = [];
  availablePassengers: any[] = [];
  tooltipOpenIndex: number | null = null;
  routesOption: boolean;

    // HostListener para detectar clicks fuera del componente
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Verificar si el click fue fuera del contenedor del pasajero
    if (this.passengerContainer &&
        !this.passengerContainer.nativeElement.contains(event.target) &&
        this.isCollapsed) {
      this.closePassengerModal();
    }
  }

    closePassengerModal(): void {
    this.isCollapsed = false;
  }

   colors = [
            '#ff4d4d',  // Rojo intenso (1 - Muy malo)
            '#ff8c66',  // Rojo-naranja (2 - Malo)
            '#ffcc00',  // Amarillo (3 - Regular)
            '#66cc66',  // Verde claro (4 - Bueno)
            '#00b359'   // Verde esmeralda (5 - Excelente)
          ];


    constructor(
    private notificationService: NotificationService,
    private _itineraryService: ItineraryService,
    private _restService: RestService,
    private _cookieService: CookieService,
    public dialog: MatDialog,
    public userService: UserService,
    public spinner: NgxSpinnerService,
    private renderer: Renderer2,
    private cdr:ChangeDetectorRef,
    private productFactory: ProductFactoryService,
    private currencyPipe: CurrencyConverterPurePipe,
  ) {}

  /**
   * Devuelve una vista resumida de un valor para logging:
   *  - null/undefined → su tag
   *  - arrays → length + primer item resumido
   *  - objects planos → sus keys + tipos
   *  - primitives → el valor directo
   * Evita spamear la consola con objetos gigantes (ej. tour con 50 campos).
   */
  private summarize(value: any, depth = 1): any {
    if (value === null) return '[null]';
    if (value === undefined) return '[undefined]';
    const t = typeof value;
    if (t !== 'object') return `${t}=${value}`;
    if (Array.isArray(value)) {
      return {
        __type: 'array',
        length: value.length,
        first: depth > 0 ? this.summarize(value[0], depth - 1) : '[...]'
      };
    }
    const keys = Object.keys(value);
    const shape: any = { __type: 'object', keys: keys.length };
    if (depth > 0) {
      shape.preview = {};
      keys.slice(0, 12).forEach(k => {
        const v = value[k];
        if (v !== null && typeof v === 'object') {
          shape.preview[k] = Array.isArray(v) ? `[array len=${v.length}]` : '[object]';
        } else {
          shape.preview[k] = v;
        }
      });
      if (keys.length > 12) shape.preview['__more'] = `${keys.length - 12} keys más`;
    }
    return shape;
  }

  /**
   * Devuelve el rango de edad (ageFrom, ageTo) para un paxType específico
   * (CHILD o INFANT) leyendo de la primera option del tour.
   * Devuelve null si no existe el paxType o no hay datos.
   * Como el orden del array puede variar, filtramos por paxType en vez de por índice.
   */
  getPaxAgeRange(paxType: 'CHILD' | 'INFANT'): { ageFrom: number; ageTo: number } | null {
    const option = this.tour?.additionalInfo?.tours?.options?.[0];
    const paxPrices = option?.paxPrices;
    if (!Array.isArray(paxPrices)) return null;
    const match = paxPrices.find(p => p?.paxType === paxType);
    if (!match) return null;
    const ageFrom = match.ageFrom;
    const ageTo = match.ageTo;
    if (ageFrom === undefined || ageFrom === null) return null;
    return { ageFrom, ageTo: ageTo ?? ageFrom };
  }

  /**
   * Devuelve true si el tour tiene datos de paxType para mostrar la columna correspondiente.
   * Útil para envolver secciones enteras con *ngIf y no mostrar la columna si no hay datos.
   */
  hasPaxType(paxType: 'CHILD' | 'INFANT'): boolean {
    return this.getPaxAgeRange(paxType) !== null;
  }

  /**
   * Devuelve true si el objeto de temporada tiene al menos una fecha `from` o `to` con valor.
   * Sirve para no renderizar la columna completa cuando ambos vienen vacíos/null/undefined.
   */
  hasSeasonDates(season: { from?: any; to?: any } | null | undefined): boolean {
    if (!season) return false;
    const from = season.from;
    const to = season.to;
    const hasFrom = from !== null && from !== undefined && from !== '';
    const hasTo = to !== null && to !== undefined && to !== '';
    return hasFrom || hasTo;
  }

  /**
   * Formatea el rango de edad para mostrar.
   * Si ageFrom === ageTo → "Edad mínima de X años"
   * Si ageTo es null/undefined → "Edad mínima de X años"
   * Si son distintos → "De X a Y años"
   */
  formatPaxAgeRange(paxType: 'CHILD' | 'INFANT'): string {
    const range = this.getPaxAgeRange(paxType);
    if (!range) return '';
    const { ageFrom, ageTo } = range;
    if (ageFrom === ageTo || ageTo === null || ageTo === undefined) {
      return `Edad mínima de ${ageFrom} años`;
    }
    return `De ${ageFrom} a ${ageTo} años`;
  }

  ngOnInit() {
    console.log("TOUR: ", this.tour);
    this.styleBookingFlow = JSON.parse(this.clientSetting.clients_setting_app_booking?.bookingFlow_body);
    this.routeUpdate = setting.apiStorageBooking;
    this.tour.additionalInfo.tours.options.forEach((option: any) => {
      option.addonsIncluded = [];
      option.netPriceBookingAddons = 0;
    });

    this._disabledButton = true;
    this.dateSelect = "";

    const componentSuggestion = this.arrayResults[0]?.component === 'suggestion' ? true : false;
    const componentSuggestionItinerary = this.arrayResults[0]?.component === 'suggestion_itinerary' ? true : false;

    if(componentSuggestion) {
       this.payload = [this.payloadUpdate];
    }
    else if (componentSuggestionItinerary) {
        this.payload = [this.tour.payload];
    } else {
      if(!this.payload) {

        this.payload = JSON.parse(localStorage.getItem("payload"));
      }

    }

    if(!this.quote) {

      this.payload = this.tour.payload;
    }

    const [year, month, day] = this.payloadUpdate.arrivalDate.split('-');
    const today = new Date(Number(year), Number(month) - 1, Number(day));
    this.currentYear = today.getFullYear();
    this.currentMonth = today.getMonth();
    this.generateCalendar();
    this.dataCommon();
    this.getPaxPricesType();

    this.tab = this.tabActive ? this.tabActive : "photos";



    if(this.tour.additionalInfo.images == null){
      this.validateImages = true;
    }

    this.tour.additionalInfo.tours.options.forEach((opt) => {
      this._itemSelected.questions = opt.questions;
    });

    this.hourSelectHidden = (this.tour.additionalInfo.tours.options.every(c => c.sessions !== null) ||
                            this.tour.scheduling && Array.isArray(this.tour.scheduling) && this.tour.scheduling.length > 0 && this.tour.scheduling[0].opened && this.tour.scheduling[0].opened.openingTime ? true : false);

    if(this.hourSelectHidden) {
      this.getOptionsGroupName();
      // this.getLanguageGuide();
      // this.getHoursAvailTickets();
    }

    this.infoArr = Array.isArray(this.tour.additionalInfo.general_info)
      ? this.tour.additionalInfo.general_info.filter((item) => item != null)
      : this.tour.additionalInfo.general_info
      ? [this.tour.additionalInfo.general_info]
      : [];

    this.adultsCount = this.payloadUpdate.others.tours.adults;
    this.childrenCount = this.payloadUpdate.others.tours.children.length;;

    this.dayInitPayload = moment(this.payloadUpdate.arrivalDate).format("YYYY-MM-DD").toString();
    this.dayFinalPayload = moment(this.payloadUpdate.departureDate).format("YYYY-MM-DD").toString();

    if(this.quote) {
      this.dateLastFrom = this.selectTour.availableDates[0].from;
      this.dateLastTo = this.selectTour.availableDates[this.selectTour.availableDates.length - 1].to;

    }

    this.daysHeaderCalendar();

    this.getAmenitiesTransfer();
    this.getComments();
       if(this.quote) {
          this.initializePassengerCounts();
       }

    this.applyImageFilter();
    this.schedulingArr();
    this.generateCoordinates();
    this.getToursItinerary();

    console.log("TOUR: ", this.tour);
    console.log("PAYLOAD: ", this.payload);
  }

  /**
   * Maneja la selección de un stop en el mapa.
   * Acepta firmas:
   *   - selectStop({ stop, index })                        → desde el marker del mapa
   *   - selectStop(stop)                                   → desde la lista de stops
   *   - selectStop({ stop, index }, option, optionIndex)  → con contexto de opción
   * Actualiza el stop seleccionado y resuelve el índice para resaltar la card.
   */
  selectStop(payload: { stop: any, index: number } | any, option?: any, optionIndex?: number): void {
    const stop = payload?.stop !== undefined ? payload.stop : payload;
    const indexFromPayload = payload?.index;

    this.selectedStop = stop;

    // Si se proporciona contexto de opción, actualizar el estado per-opción
    if (option !== undefined && optionIndex !== undefined) {
      const key = this._getCronogramaKey(option, optionIndex);
      const state = this._cronogramaStateByOption.get(key);
      if (state) {
        let resolvedIndex: number;
        if (typeof indexFromPayload === 'number') {
          resolvedIndex = indexFromPayload;
        } else {
          const idx = state.stopsRoute.findIndex(
            (s: any) => s === stop || s?.order === stop?.order
          );
          resolvedIndex = idx >= 0 ? idx : 0;
        }
        state.selectedRouteIndex = resolvedIndex;
        this._cronogramaStateByOption.set(key, state);
      }
    }

    // Mantener compat con la lógica vieja
    if (stop?.coordinates) {
      this.coordinatesSelected = stop.coordinates;
    }
  }

  getToursItinerary(): void {

     const subCategory = this.quote ? this.payload[0].categoriesId[0] : this.tour.payload[0].categoriesId[0];
     const items: any[] = this._itineraryService.itinerary.items && this._itineraryService.itinerary.items && this._itineraryService.itinerary.items.length > 0 ? this._itineraryService.itinerary.items : [];

    if(items && items.length === 0) {
      return;
    }

     const toursItems: any[] = items.filter(c => c.categoryId === 6);

     if(toursItems && toursItems.length === 0) {
      return;
     }

     switch(subCategory) {
      case 6:
        this.othersProductsToursItinerary = toursItems.filter(c => c.subCategoryId === 6) || [];
        break;
      case 9:
        this.othersProductsToursItinerary = toursItems.filter(c => c.subCategoryId === 9) || [];
        break;
     }

  }

  getBackgroundColor(day: any): string {
    // Día seleccionado
    if (day.isAvailable && day.isCurrentMonth && !this.getItineraryDayInItinerary(day) && day.date === this.dateSelect) {
        return this.buttonColorActive;
    }
    // Día disponible del mes actual (no seleccionado)
    if (day.isAvailable && day.isCurrentMonth && !this.getItineraryDayInItinerary(day)) {
        return '#d5f9ed';
    }
    if (!day.isCurrentMonth) {
      return '#f4f6f5';
    }

    if(this.getItineraryDayInItinerary(day)) {
      return 'repeating-linear-gradient(-45deg, #ffffff 0px, #ffffff 7px, #f0f0f0 7px, #f0f0f0 8px)';
    }

    // Días no disponibles o de otros meses
    return '#ffffff';
}


/**
 * Verifica si dos fechas son consecutivas (día siguiente)
 */
private isConsecutiveDay(date1: string, date2: string): boolean {
  if (!date1 || !date2) return false;

  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Resetear horas para comparar solo fechas
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);

  const diffTime = d2.getTime() - d1.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  return diffDays === 1;
}

/**
 * Obtiene la posición del día dentro del bloque
 */
getDayPosition(day: any, allDays: any[], index: number): { isFirst: boolean; isLast: boolean } {
  if (!this.isPartOfUnavailableBlock(day)) {
    return { isFirst: false, isLast: false };
  }

  const prevDay = index > 0 ? allDays[index - 1] : null;
  const nextDay = index < allDays.length - 1 ? allDays[index + 1] : null;

  // Verificar si el día anterior es parte del mismo bloque
  const isPrevInBlock = prevDay &&
                        this.isPartOfUnavailableBlock(prevDay) &&
                        this.isConsecutiveDay(prevDay.date, day.date);

  // Verificar si el día siguiente es parte del mismo bloque
  const isNextInBlock = nextDay &&
                        this.isPartOfUnavailableBlock(nextDay) &&
                        this.isConsecutiveDay(day.date, nextDay.date);

  return {
    isFirst: !isPrevInBlock,
    isLast: !isNextInBlock
  };
}

/**
 * Obtiene el rango de fechas del bloque
 */
getRangeDateUnavailable(day: any, allDays: any[], index: number): string {

  // Salida temprana: no es parte del bloque
  if (!this.isPartOfUnavailableBlock(day)) {
    return '';
  }

  // Buscar el primer día del bloque (hacia atrás)
  let startIndex = index;
  for (let i = index - 1; i >= 0; i--) {
    const current = allDays[i];
    const next = allDays[i + 1];

    if (!current || !this.isPartOfUnavailableBlock(current)) {
      break;
    }

    const isConsecutive = this.isConsecutiveDay(current.date, next.date);
    if (!isConsecutive) {
      break;
    }
    startIndex = i;
  }

  // Solo mostrar si este día es el primero del bloque
  if (startIndex !== index) {
    return '';
  }

  // Buscar el último día del bloque (hacia adelante)
  let endIndex = index;
  for (let i = index + 1; i < allDays.length; i++) {
    const current = allDays[i];
    const previous = allDays[i - 1];

    if (!current || !this.isPartOfUnavailableBlock(current)) {
      break;
    }

    const isConsecutive = this.isConsecutiveDay(previous.date, current.date);
    if (!isConsecutive) {
      break;
    }
    endIndex = i;
  }

  // CORRER UN DÍA: sumar 1 al inicio y 1 al final
  const startDate = new Date(allDays[startIndex].date);
  const endDate = new Date(allDays[endIndex].date);

  startDate.setDate(startDate.getDate() + 1);
  endDate.setDate(endDate.getDate() + 1);

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const month = startDate.toLocaleString('es', { month: 'long' }).toUpperCase();

  if (startDay === endDay) {
    return `${startDay} DE ${month}`;
  }

  return `${startDay} AL ${endDay} DE ${month}`;
}

getItineraryDayInItinerary(day: any): boolean {
  if (!this.othersProductsToursItinerary?.length || !day?.date) {
    return false;
  }

  // Normalizar fecha a string YYYY-MM-DD
  const formatDate = (date: any): string => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.toISOString().split('T')[0];
  };

  const targetDate = formatDate(day.date);

  return this.othersProductsToursItinerary.some(item =>
    formatDate(item.arrivalDate) === targetDate
  );
}

getTourItineraryCalendar(day: any): any {
    if (!this.othersProductsToursItinerary?.length || !day?.date) {
    return false;
  }

  let product: any;

  // Normalizar fecha a string YYYY-MM-DD
  const formatDate = (date: any): string => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.toISOString().split('T')[0];
  };

  const targetDate = formatDate(day.date);

  product = this.othersProductsToursItinerary.find(item =>
    formatDate(item.arrivalDate) === targetDate
  );

  return product;
}

    generateCoordinates(): void {
      const subCategory = this.quote ? this.payload[0].categoriesId[0] : this.tour.payload[0].categoriesId[0];

      // Obtener precio: profility (productos cotizados) o paxPrices (sugerencias)
      const option = this.tour.additionalInfo?.tours?.options?.[0];
      let price: number | null = null;
      if (option?.profility) {
        price = option.profility.find(c => c.paxType === 'ADULT')?.netPriceBooking;
      } else if (option?.paxPrices) {
        price = option.paxPrices.find(c => c.paxType === 'ADULT')?.amount;
      }

      this.coordinatesArr = [{
              coordinates:{latitude: Number(this.tour.additionalInfo?.location_gps?.latitude), longitude: Number(this.tour.additionalInfo?.location_gps?.longitude)},
              hotel_name: this.tour.title,
              address: this.tour.additionalInfo?.location,
              rateClass: option?.rateClass,
              cancellationPolicies: this.getCancellationPoliciesMap(option, subCategory),
              price: price,
              images: this.tour.additionalInfo?.images,
              views: this.tour.views,
              id: this.tour.productId,
              currency: this.tour?.additionalInfo?.currency,
              generalMap: false,
              origin: this.origin
            }];

    }

    get cancellationPolicyDate(): Date | null {
      const policy = this.tour?.additionalInfo?.tours?.options?.[0]?.cancellation_policy;
      return policy && policy.length > 0 ? policy[0]?.dateFrom : null;
    }

    getCancellationPoliciesMap(option: any, subCategory: number): any[] {
    // Validación inicial
    if (!option) {
        console.warn('Option es null o undefined');
        return [];
    }

    let cancellationArr: any[] = [];

    try {
        switch(subCategory) {
            case 6:
                // Validación para caso 6
                if (option?.cancellationPolicies?.[0]?.cancellationPolicies) {
                    const policies = option.cancellationPolicies[0].cancellationPolicies;
                    cancellationArr = Array.isArray(policies) ? policies : [];
                } else {
                    console.warn('No se encontraron cancellationPolicies para subCategory 6');
                }
                break;

            case 9:
                // Validación para caso 9
                if (option?.availableDates?.[0]?.cancellationPolicies) {
                    const policies = option.availableDates[0].cancellationPolicies;
                    cancellationArr = Array.isArray(policies) ? policies : [];
                } else {
                    console.warn('No se encontraron cancellationPolicies para subCategory 9');
                }
                break;

            default:
                console.warn(`subCategory ${subCategory} no manejado`);
                return [];
        }
    } catch (error) {
        console.error('Error al obtener cancellationPolicies:', error);
        return [];
    }

    return cancellationArr;
}

  dataCommon(): void {
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.agency = JSON.parse(localStorage.getItem("selectedAgency"));
    this.clientSetting = JSON.parse(localStorage.getItem(setting.name));

    this.textInfoExtra = this.tour.additionalInfo.extra_info;

    if(this.hoursAvailable) {
        const grouped = new Map();

        for (const option of this.tour.additionalInfo.tours.options) {
          const name = (option.option_name || option.name || 'Sin nombre');
          if (!grouped.has(name)) {
            grouped.set(name, option);
          }
        }

        this.optionsTour = Array.from(grouped.values());

    } else {
      this.optionsTour = this.tour.additionalInfo.tours.options;
    }

    this.selectTour = this.tour.additionalInfo.tours.options[0]; // seleccionar el prmer tour
    this.currencySelected = this.tour.additionalInfo.currency;
  }

  close() {
    this._emitRefModal("close");
  }

  getdataSubscription() {
    this._itineraryService.dateCatchSelect$.subscribe((res: any) => {
      this.dateSelect = res;
    });

    this._itineraryService.valueCatchBoolean$.subscribe((res: boolean) => {
      this._disabledButton = res;
    });

    this._itineraryService.titleHotelUnique$.subscribe((res: any) => {
      this.titleSelectUniqueHotel = res;
    });
  }

async continue(option: any) {


  if (!this._itemSelected?.availableDate?.arrivalDate) {
    this.notificationService.warning(`Elija una fecha del calendario para su experiencia`);
    this.continueValidProcess = true;
    return;
  }

  if (!this.continueValidProcess) return;

  this.continueValidProcess = false;

  try {
    const categoryId = this.payload[0].categoriesId[0];

    if (categoryId === 6) {
      const optionSelected = await this.addItinerary(this.tour, option);


      if (optionSelected) {
        this._itineraryService.sendMessageSubscriptorLoading(true);
        this.handleProductAddition(optionSelected);
      }
    }
    else if (categoryId === 9) {

            // ✅ VALIDACIÓN: Verificar que cada ticket tenga al menos un adulto
      const validationResult = this.validateTicketsHaveAdultDetailed();

      if (!validationResult.isValid) {
        this.continueValidProcess = true;
        this.notificationService.warning(validationResult.message);
        return;
      }

      const productItineraryArr: any[] = [];


      if (this.ticketsSelected && this.ticketsSelected.length > 0) {
        // Procesar cada ticket con copias profundas
        for (let i = 0; i < this.ticketsSelected.length; i++) {
          try {
            // Crear copia profunda del ticket
            const ticketCopy = this.createTicketCopyWithId(this.ticketsSelected[i], i);

            const optionSelected = await this.addItinerary(this.tour, ticketCopy);

            if (optionSelected) {
              productItineraryArr.push(optionSelected);
            }
          } catch (error) {
            this.continueValidProcess = true;
            console.error(`Error procesando ticket ${i}:`, error);
          }
        }
      }
      if (productItineraryArr.length > 0) {
        // Procesar productos uno por uno con delay
        await this.processProductsSequentially(productItineraryArr);
      } else {
        this.continueValidProcess = true;
        this.notificationService.warning('No se pudo crear el producto');
      }
    }

  } catch (error) {
    console.error('Error al procesar:', error);
    this.notificationService.error('Ocurrió un error al procesar la solicitud');
    this.continueValidProcess = true;
  }
}


/**
 * Versión más detallada con información de qué falta exactamente
 */
validateTicketsHaveAdultDetailed(): {
  isValid: boolean;
  message: string;
  details: Array<{ ticketIndex: number; currentPassengers: string[] }>
} {
  const details: Array<{ ticketIndex: number; currentPassengers: string[] }> = [];

  for (let i = 0; i < this.ticketsSelected.length; i++) {
    const ticket = this.ticketsSelected[i];
    const passengerTypes = ticket.assignedPassengers?.map((p: any) => p.type) || [];
    const hasAdult = passengerTypes.includes('ADULT');

    if (!hasAdult) {
      details.push({
        ticketIndex: i + 1,
        currentPassengers: passengerTypes
      });
    }
  }

  if (details.length > 0) {
    let message = '';
    if (details.length === 1) {
      const tipos = details[0].currentPassengers.length > 0
        ? `(tiene: ${details[0].currentPassengers.join(', ')})`
        : '(sin pasajeros asignados)';
      message = `El ticket #${details[0].ticketIndex} ${tipos} debe tener al menos un adulto asignado.`;
    } else {
      const ticketsList = details.map(d => `#${d.ticketIndex}`).join(', ');
      message = `Los tickets ${ticketsList} no tienen un adulto asignado. Cada ticket requiere al menos un adulto.`;
    }

    return {
      isValid: false,
      message,
      details
    };
  }

  return {
    isValid: true,
    message: '',
    details: []
  };
}

  getFlagByLanguageName(language: any): any {
    return flagByLanguageNameExperience(language);
  }

/**
 * Procesa productos de forma secuencial con delay
 */
private async processProductsSequentially(products: any[]): Promise<void> {
  for (let i = 0; i < products.length; i++) {
    try {

      this._itineraryService.sendMessageSubscriptorLoading(true);
      await this.handleProductAdditionWithDelay(products[i], i * 500); // Delay entre productos

    } catch (error) {
      console.error(`Error agregando producto ${i}:`, error);
    }
  }

  // Finalizar proceso
  setTimeout(() => {
    this.handleResItineraryUpdateSuccesfull();
    this.continueValidProcess = true;
  }, products.length * 500 + 1000);
}

/**
 * Crea una copia profunda de un ticket con identificación única
 */
private createTicketCopyWithId(ticket: any, index: number): any {
  const copy = this.deepCopy(ticket);

  // Agregar identificadores únicos para debug y tracking
  copy.uniqueId = `ticket_${Date.now()}_${index}_${Math.random().toString(36).substr(2, 9)}`;
  copy.originalIndex = index;

  // Asegurarse de que paxType también es una copia profunda
  if (copy.paxType) {
    copy.paxType = this.deepCopy(copy.paxType);
  }

  return copy;
}

/**
 * Maneja la adición de producto con delay
 */
private handleProductAdditionWithDelay(product: any, delay: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      this.handleProductAddition(product);
      resolve();
    }, delay);
  });
}
  /**
 * Crea una copia profunda de un objeto, manejando arrays, objetos y fechas
 */
private deepCopy<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // Si es un Date
  if (obj instanceof Date) {
    return new Date(obj.getTime()) as any;
  }

  // Si es un Array
  if (Array.isArray(obj)) {
    return obj.map(item => this.deepCopy(item)) as any;
  }

  // Si es un objeto regular
  const copy = {} as any;
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      copy[key] = this.deepCopy((obj as any)[key]);
    }
  }
  return copy;
}


    /**
     * Maneja la respuesta del servidor al agregar un producto
     * @param item Producto a agregar
     * @param toastId ID del toast de carga para removerlo
     */
    private handleProductAddition(item: IExperiencieProduct): void {
      this._itineraryService.add(item).subscribe({
        next: (response: IExperiencieProduct) => {
          if (response) {
            this._itineraryService.itinerary.arrivalDate = item.arrivalDate;
            this._itineraryService.itinerary.departureDate = item.departureDate;
            this.notificationService.success("¡Felicitaciones! Producto agregado con éxito.");
          this.handleResItineraryUpdateSuccesfull();
            this._emitRefModal("success");
          } else {
            this._emitRefModal("error");
            console.warn('Respuesta vacía del servidor:', response);
            this.notificationService.error('No se recibió confirmación del servidor', 'Error');
          }
        },
        error: (error: HttpErrorResponse) => {
          this._emitRefModal("error");
          console.error('Error adding product:', error);

          this._itineraryService.sendMessageSubscriptorLoading(false);

          // Mensaje de error más específico
          const errorMessage = this.getErrorMessage(error);
          this.notificationService.error(errorMessage, 'Error');
        }
      });
    }

      /**
   * Obtiene mensaje de error amigable basado en el tipo de error HTTP
   * @param error Error HTTP recibido
   * @returns Mensaje de error traducido
   */
  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'Error de conexión. Verifique su internet.';
    } else if (error.status >= 500) {
      return 'Error del servidor. Intente nuevamente.';
    } else {
      return 'Ha ocurrido un error al agregar el producto';
    }
  }

    /**
   * Maneja la actualización exitosa del itinerario
   * Actualiza impuestos, fechas y envía al servidor
   */
  private handleResItineraryUpdateSuccesfull(): void {
    this._itineraryService.sendMessageSubscriptorLoading(false);
    this._itineraryService.itinerary.clientId = this.clientSetting?.id;
    this._itineraryService.evaluateDateItineraryRange(this._itineraryService.itinerary["items"]);
    this._itineraryService.itinerary.currency = this.currencySelected;

    this._itineraryService.updateItinerary(this._itineraryService.itinerary);
  }

async  addItinerary(item: any, tour: any): Promise<any> {

    // Guest sin file/owner todavía: los crea acá mismo, con placeholder, antes
    // del chequeo de owner de siempre (no-op para agente real).
    await this._itineraryService.ensureGuestItinerary();

    //validar si owner esta lleno
    if (!isValidOwener(this._cookieService.get("clientActive"))) {
      //this.notificationService.warning(fillOwnerMessage());
      return;
    }

    if( this.payload[0].categoriesId[0] === 9) {

      if(!this._itemSelected?.availableDate?.arrivalDate) {
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione una fecha');
      }

      if(!this.hourSelected) {
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione un horario');
      }

      if(!this.ticketsSelected) {
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione una opción');
      }

    }

    if(this.payload[0].categoriesId[0] === 6) {

       if(this.getLanguageGuide(tour).length > 1 && !this.languageSelected) {
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione un idioma');
        return
      }

      if(this.getHoursAvailTickets(tour).length > 1 && !this.hourSelected) {
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione un horario');
        return
      }


      let tourOption: any;

      if(this.getLanguageGuide(tour).length > 0 && this.getHoursAvailTickets(tour).length > 0) {
        tourOption = item.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected &&
                                                                  c.language === this.languageSelected);
      }

       if(this.getLanguageGuide(tour).length > 0 && this.getHoursAvailTickets(tour).length === 0) {
        tourOption = item.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected);
      }

      if(this.getLanguageGuide(tour).length === 0 && this.getHoursAvailTickets(tour).length > 0) {
        tourOption = item.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected);
      }

      if(tourOption) {
        tour = tourOption;
      }

    }
        if(!tour) {
      if(!this.hourSelected) {
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione un horario');
      }

      tour = this.getTourResultsAddItinerary(item);
      if(!tour) {
        this.continueValidProcess = true;
        console.error('No hay tour encontrado');
        return;
      }
    }

    // Crear copia del tour para evitar mutaciones
    const tourCopy = this.deepCopy(tour);

    // Crear copia del item
    const itemCopy = this.deepCopy(item);

    const loadingToast = this.notificationService.loading('Procesando producto...');

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {

           const categoryId: number = this.payload[0].categoriesId[0];
           const productService = this.productFactory.getProductService(categoryId);
           let others: any;

            if(categoryId === 6) {



                others = {
                  searchId:  this.arrayResults.searchid,
                  arrivalDate: this._itemSelected.availableDate.arrivalDate,
                  paxNumber: this.totalPassengers,
                  paxesData: this.getPaxPricesWithTotals(tour.optionId),
                  hourSelectHidden: this.hourSelectHidden,
                  childAges: this.childAges,
                  payloadUpdate: this.payloadUpdate,
                  userService: this.userService,
                  suggestion: this.arrayResults[0]?.component === 'suggestion' || this.arrayResults[0]?.component === 'suggestion_itinerary' ? true : false,
                  from: this.from
                };

            }

            else if(categoryId === 9) {

              others = {
                searchId: this.arrayResults.searchid,
                arrivalDate: this._itemSelected.availableDate.arrivalDate,
                hourSelectHidden: this.hourSelectHidden,
                hourSelected: this.hourSelected,
                childAges: this.childAges ? [...this.childAges] : [],
                payloadUpdate: this.payloadUpdate ? this.deepCopy(this.payloadUpdate) : null,
                indexPaxMandatory: this.indexPaxMandatory,
                paxTypeDiferent: this.getPaxesTypeSelectedDiferent(),
                userService: this.userService,
                from: this.from
              };

            } else {
              this.continueValidProcess = true;
              this.notificationService.warning('Categoría no encontrada');
            }

           const productParams: IProductCreationParams = {
              item: itemCopy,
              product: tourCopy,  // Usar la copia
              payload: this.deepCopy(this.payload),
              categoryId,
              othersPerCategory: others
            };

            const result = productService.createProduct(productParams);

            this.notificationService.close(loadingToast);

        resolve(result);

        } catch (error) {
            this.continueValidProcess = true;
            this.notificationService.close(loadingToast);
            console.error('Error en addToItinerary:', error);
            this.notificationService.warning('Hay un problema en el producto');
            reject(error);

        }
      }, 100);
    });
  }

  // getTourResultsAddItinerary(product: any, experience: any): any {
  //   // console.log(experience)
  //   if (this.getLanguageGuide(experience).length > 1) {
  //     return product.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected &&
  //                                                                 c.language === this.languageSelected);
  //   }
  //   else if(this.getLanguageGuide(experience).length === 1) {
  //      return product.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected);
  //   }
  // }

    getTourResultsAddItinerary(experience: any): any {
    // console.log(experience)
    if (this.getLanguageGuide(experience).length > 1) {
      // console.log(experience.additionalInfo?.tours?.options)
      // console.log(this.hourSelected)
      // console.log(this.languageSelected)
      return this.tour.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected &&
                                                                  c.language === this.languageSelected);
    }
    else if(this.getLanguageGuide(experience).length === 1) {
       return this.tour.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected);
    }
  }

  closeModal() {
    this._findData = false;
    this._select = null;
    this._disabledButton = false;
    this.dateSelect = null;
    this._emitRefModal("fail close modal");
  }

  setTotal(index: any) {
    this._select = index;
    this._total = this._itemOption.netPriceProf;
    this._disabledButton = this.verifyButton();

  }

  activeDate(itemSelected: any) {
    this.dateSelected = true;
    this._itemSelected.availableDate = this.getDatesSelected(itemSelected);
  }

  setItemDate(itemSelected: any, itemTours: any) {


    if (itemSelected != null) {
      this._itemSelected.availableDate = this.getDatesSelected(itemSelected);
    }

    if(itemTours.length === 0) {
      return;
    }

    itemTours.forEach((item: any) => {
      if (item.availableDates && this.tour.additionalInfo.tours.hasReservationQuestions) {
              this._loadDates = true;


               var payload = this.getPayloadSearchDetailsToReservation(item);



               this._restService.doPost("api", "/searchdetailstoreservation", payload).subscribe({
                  next: (res: any) => { }
               });


      };
    });


    this.itemsTour.push(itemTours);

    if (itemTours.availableDates && itemTours.availableDates.length == 0 && this.tour.additionalInfo.tours.hasReservationQuestions) {
      this._loadDates = true;

      var payload = this.getPayloadSearchDetailsToReservation(itemTours);

      this._restService.doPost("api", "/searchdetailstoreservation", payload).subscribe(
        (response: any) => {
          this.notFoundDates = response.results.length == 0;
          if (itemTours.availableDates) {
            itemTours.availableDates = this.getArrivalDateFromResponse(response);
            this.dateAvailablesReady = true;
          }
          this._itemSelected.questions = response.results.questions;

          this._loadDates = false;
        },
        (error) => {
          console.log(error);
          this._loadDates = false;
          this.notFoundDates = true;
        }
      );
    } else {
      if (this.dateAvailablesReady) {
        //this._disabledButton = !(this._select !== undefined && this._itemSelected.availableDate !== undefined);
        this._disabledButton = this.verifyButton();
        return;
      }

      this.tour.additionalInfo.tours.options.forEach((element) => {
        if (element.name == itemTours.name) {
          element.availableDates.forEach((toursDates) => {
            this.toursAvailableDates.push(toursDates);
          });
        }
      });

      itemTours.availableDates = this.toursAvailableDates;
      this.dateAvailablesReady = true;
    }

    this._disabledButton = this.verifyButton();
  }

  verifyButton(): boolean {
    //if(this._select && this._itemSelected.availableDate){
    if (this._select && this.dateSelected) {
      return false;
    } else {
      return true;
    };
    return true;
  }

  _emitRefModal(status: string) {
    this.refModal.emit(status);
    this._disabledButton = true;
  }

  /**
   * Arma el payload de busqueda para el endPoint
   * @link /api/v1/app/searchdetailstoreservation/
   * @param item
   *
   */
  getPayloadSearchDetailsToReservation(item: any) {
    item.paxesData = this.getPaxPricesWithTotals(item.optionId);
    var payload = {
      providerId: this.tour.providerId,
      nameAdapter: this.tour.nameAdapter,
      dateIni: this.tour.dateIni,
      dateEnd: this.tour.dateEnd,
      adults: item.paxesData.find(c => c.paxType === 'ADULT').passengerCount,
      children:item.paxesData
                              .filter(c => c.paxType === 'CHILD')
                              .reduce((sum, child) => sum + child.passengerCount, 0),
      productId: this.tour.productId,
      optionId: item.optionId,
      hasReservationQuestions: this.tour.additionalInfo?.tours?.hasReservationQuestions,
      company: this.tour.additionalInfo?.tours?.company,
    };
    return payload;
  }

  /**
   * Obtiene el arreglo de fechas disponibles para los tours de Hotel Beds
   * @param response
   */
  getArrivalDateFromResponse(response: any) {
    var dateAvailable = [];
    if (response && response.results) {
      if (response.results.availableDates) {
        response.results.availableDates.forEach((element) => {
          dateAvailable.push(element.from + " / " + element.to);
        });
      }
    }
    return dateAvailable;
  }

  getDatesSelected(itemSelected: string) {
    var dates;
    // if (itemSelected && itemSelected !== this._selectDate) {
    dates = {
      arrivalDate: itemSelected,
      departureDate: itemSelected,
      //   }
      /* if (itemSelected.includes('/')) {
        var datesArray = itemSelected.split('/');
        dates = {
          arrivalDate: datesArray[0],
          departureDate: datesArray[1]
        }
      } else {
        dates = {
          arrivalDate: itemSelected,
          departureDate: itemSelected
        }
      }*/
    };
    this.dateSelected = true;
    return dates;
  }

  mapMarker() {
    //se inicializa el mapa con zoom 4
    // let latitudeValue = this.tour.additionalInfo.location_gps.latitude;
    // let longitudeValue = this.tour.additionalInfo.location_gps.longitude;
    // const myLatLang = new google.maps.LatLng(latitudeValue, longitudeValue)
    // var geocoder;
    // var mapa;
    // var mapOptions = {
    //   center: myLatLang,
    //   zoom: 4,
    //   mapTypeId: google.maps.MapTypeId.ROADMAP,
    // };
    // //seteamos el maa
    // mapa = new google.maps.Map(this.gmapElement.nativeElement, mapOptions);
    // //buscamos las coordenadas con la direccion dada del hotel
    // geocoder = new google.maps.Geocoder();
    // var title =  this.tour.title;
    // geocoder.geocode({ address: this.tour.additionalInfo.location.trim() }, (results, status) => {
    //   if (status.toString() == "OK") {
    //     var marker = new google.maps.Marker({
    //       map: mapa,
    //       position: myLatLang,
    //       title: title,
    //     });
    //     google.maps.event.trigger(mapa, "resize");
    //     //colocamos el market
    //     mapa.panTo(marker.getPosition());
    //     mapa.setZoom(16);
    //     marker.setMap(mapa);
    //   } else {
    //     console.log("No se obtuvo la ubicacion del mapa: " + status);
    //   }
    // });
    // mapa.set("parent", this);
  }

  /* mapMarker(){
    //se inicializa el mapa con zoom 4
    this.tab = 'maps'
    const lat = this.tour.additionalInfo.location_gps.latitude;
    const lng = this.tour.additionalInfo.location_gps.longitude;
    console.log('latitude ->', lat);

    let mapa:any;
    const mapOptions = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    //seteamos el maa
    mapa = new google.maps.Map(this.gmap.nativeElement, mapOptions);

    new google.maps.Marker({position: {lat: lat, lng: lng}, map: mapa});
    mapa.set('parent', this);
  } */

  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stingUpperCase(str) {
    let e = str.toLowerCase();
    return e.replace(/\b\w/g, (l) => l.toUpperCase());
  }

  week() {
    return [
      'Lun',
      'Mar',
      'Mie',
      'Jue',
      'Vie',
      'Sab',
      'Dom'
    ]
  }

generateCalendar() {
  const year = this.currentYear;
  const month = this.currentMonth;

  const startDate = new Date(year, month, 1);
  const endDate = new Date(year, month + 1, 0);
  const daysInMonth = endDate.getDate();

  // Obtener el día de la semana del primer día (0 = Domingo, 1 = Lunes, etc.)
  const firstDayOfWeek = startDate.getDay();

  // Ajustar para que la semana comience en LUNES (1)
  let daysFromPrevMonth = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

  // Obtener el día de la semana del último día del mes
  const lastDayOfWeek = endDate.getDay();

  // Ajustar para nuestra escala (Lunes=0, Domingo=6)
  let adjustedLastDayOfWeek = lastDayOfWeek === 0 ? 6 : lastDayOfWeek - 1;

  // Calcular días del mes siguiente necesarios para terminar en domingo
  let daysFromNextMonth = 6 - adjustedLastDayOfWeek;
  daysFromNextMonth = daysFromNextMonth < 0 ? 0 : daysFromNextMonth;

  const totalDays = daysFromPrevMonth + daysInMonth + daysFromNextMonth;
  const calendar = [];
  const firstOption = this.tour?.additionalInfo?.tours?.options?.[0];

  // Agregar días del mes anterior (si es necesario)
  if (daysFromPrevMonth > 0) {
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevMonthYear = month === 0 ? year - 1 : year;
    const daysInPrevMonth = new Date(prevMonthYear, prevMonth + 1, 0).getDate();

    for (let i = daysInPrevMonth - daysFromPrevMonth + 1; i <= daysInPrevMonth; i++) {
      const date = moment(new Date(prevMonthYear, prevMonth, i)).format("YYYY-MM-DD").toString();
      const isAvailable = firstOption?.availableDates?.some((d) => date >= d.from && date <= d.to) ?? false;
      const totalPriceProf = firstOption?.pricing?.find(c => c.paxType === 'ADULT')?.netPriceProf ?? 0;

      // Determinar si está en la última semana
      const isLastWeek = false; // Los días del mes anterior nunca están en la última semana

      calendar.push({
        date,
        number: i,
        isCurrentMonth: false,
        isPrevMonth: true,
        totalPriceProf,
        isAvailable,
        isLastWeek
      });
    }
  }

  // Agregar días del mes actual
    for (let i = 1; i <= daysInMonth; i++) {
      const date = moment(new Date(year, month, i)).format("YYYY-MM-DD").toString();
      const isAvailable = firstOption?.availableDates?.some((d) => date >= d.from && date <= d.to) ?? false;
      const totalPriceProf = firstOption?.prices?.[firstOption.prices.length - 1]?.amountProf ?? 0;

    // Determinar si está en la última semana
    const dayIndex = daysFromPrevMonth + i - 1;
    const isLastWeek = dayIndex >= totalDays - 7;

    calendar.push({
      date,
      number: i,
      isCurrentMonth: true,
      isPrevMonth: false,
      isNextMonth: false,
      totalPriceProf,
      isAvailable,
      isLastWeek
    });
  }

  // Agregar días del mes siguiente (solo los necesarios para terminar en domingo)
  if (daysFromNextMonth > 0) {
    const nextMonth = month === 11 ? 0 : month + 1;
    const nextMonthYear = month === 11 ? year + 1 : year;

    for (let i = 1; i <= daysFromNextMonth; i++) {
      const date = moment(new Date(nextMonthYear, nextMonth, i)).format("YYYY-MM-DD").toString();
      const isAvailable = firstOption?.availableDates?.some((d) => date >= d.from && date <= d.to) ?? false;
      const totalPriceProf = firstOption?.prices?.[firstOption.prices.length - 1]?.amountProf ?? 0;

      // Los días del mes siguiente siempre están en la última semana
      const isLastWeek = true;

      calendar.push({
        date,
        number: i,
        isCurrentMonth: false,
        isPrevMonth: false,
        isNextMonth: true,
        totalPriceProf,
        isAvailable,
        isLastWeek
      });
    }
  }
  // return calendar;

  this.calendarDays = calendar;
  console.log(this.calendarDays)

}

/**
 * Verifica si un día tiene experiencia en el itinerario
 */
hasExperience(day: any): boolean {
  return this.getItineraryDayInItinerary(day);
}

/**
 * Verifica si un día es parte del bloque (no disponible Y sin experiencia)
 */
isPartOfUnavailableBlock(day: any): boolean {
  return !day.isAvailable && day.isCurrentMonth && !this.hasExperience(day);
}

/**
 * Determina si el día debe tener la franja negra en el borde izquierdo
 * Se muestra SOLO si el día anterior también es parte del bloque
 */
shouldHaveLeftStripe(day: any, index: number): boolean {
  // Solo para días que son parte del bloque
  if (!this.isPartOfUnavailableBlock(day)) {
    return false;
  }

  const allDays = this.calendarDays;
  const prevDay = index > 0 ? allDays[index - 1] : null;

  // ✅ Tiene franja izquierda SOLO si el día anterior también es parte del bloque y es consecutivo
  const hasPrevInBlock = prevDay !== null &&
                         this.isPartOfUnavailableBlock(prevDay) &&
                         this.isConsecutiveDay(prevDay.date, day.date);

  return hasPrevInBlock;
}

/**
 * Determina si el día debe tener la franja negra en el borde derecho
 * Se muestra SOLO si el día siguiente también es parte del bloque
 */
shouldHaveRightStripe(day: any, index: number): boolean {
  // Solo para días que son parte del bloque
  if (!this.isPartOfUnavailableBlock(day)) {
    return false;
  }

  const allDays = this.calendarDays;
  const nextDay = index < allDays.length - 1 ? allDays[index + 1] : null;

  // ✅ Tiene franja derecha SOLO si el día siguiente también es parte del bloque y es consecutivo
  const hasNextInBlock = nextDay !== null &&
                         this.isPartOfUnavailableBlock(nextDay) &&
                         this.isConsecutiveDay(day.date, nextDay.date);

  return hasNextInBlock;
}

  prevMonth() {

      const actualMonth = new Date().getMonth();

      if(actualMonth !== this.currentMonth){
        if (this.currentMonth === 0) {
          this.currentMonth = 11;
          this.currentYear--;
        } else {
          this.currentMonth--;
        }
        this.generateCalendar();
      }


  }

  nextMonth() {

    if (this.currentMonth === 11) {
      this.currentMonth = 0;
      this.currentYear++;
    } else {
      this.currentMonth++;
    }
    this.generateCalendar();
  }

  getNameMonth() {
    return moment(new Date(this.currentYear, this.currentMonth)).format("MMMM YYYY");
  }


  getDateClick(date: any, day: any) {


    if(this.getItineraryDayInItinerary(day)) {
      return;
    }

      if(this.payload[0].categoriesId[0] === 6) {

        if(this.languageSelected) {
          this.languageSelected = '';

          setTimeout(() => {
           this.mySelectLanguage.nativeElement.value = null;
          });
        }


        if(this.hourSelected) {
            this.hourSelected = '';

            setTimeout(() => {
             this.mySelectHour.nativeElement.value = null;
            });

          }
      }

      if(this.payload[0].categoriesId[0] === 9) {

          if(this.ticketsSelected && this.ticketsSelected.length > 0) {
            this.ticketsSelected = [];

              setTimeout(() => {
                  this.mySelect.value = this.ticketsSelected;
                });
          }

          if(this.hourSelected) {
            this.hourSelected = '';

            setTimeout(() => {
             this.mySelectHour.nativeElement.value = null;
            });

          }
        }

    this.dateSelect = date;
    this._itemSelected.availableDate = this.getDatesSelected(this.dateSelect);

    this._itemSelected.availableDate.arrivalDate = this.dateSelect;
    this._itemSelected.availableDate.departureDate = this.dateSelect;

    let valueButtonChange = false;

    if (date < this.dateLastFrom || date > this.dateLastTo) {
      valueButtonChange = true;
    }

    this._itineraryService.dateCatchSelect$.next(date);
    this._disabledButton = valueButtonChange;
    this.dateSelect = date;

    // this.setItemDate(date, this.tour?.additionalInfo?.tours?.options);
  }

  getUniqueHotelSelect(amenitiesTransfer: any) {
    // console.log('title-hotel -->', hotelsObj);
    this._itineraryService.titleHotelUnique$.next(title);
    this.titleSelectUniqueHotel = amenitiesTransfer.serviceExtraCatalogue || amenitiesTransfer.title;
    this.totalPriceTransfer = amenitiesTransfer.totalPrice;
  }

  /**
   * Estructura para enviar al item de producto para los servicios extras.
   * @returns Retorna el objeto del servicio extra.
   */

  servicesExtras() {
    const name = this.titleSelectUniqueHotel;
    const price = this.totalPriceTransfer;
    // const product_id = this.tour.additionalInfo.tours.options[0].tourId;

    if (!name || price == null) {
      return [];
    }

    return [{ name, price }];
  }

  getRandomUniqueId() {
    return Math.floor(Math.random() * 20000000000000) + Date.now();
  }

  getPricesTours(selectTours: any) {
    this.arrayPricesPassengers = [];

    if(!selectTours.prices){
      selectTours.prices.forEach((prices: any) => {
        this.arrayPricesPassengers.push(prices);
      });
    }
  }

  daysHeaderCalendar(): void {
    moment.locale("es");

    let payloadDateInitial = moment(this.payloadUpdate.arrivalDate);
    let payloadDateFinal = moment(this.payloadUpdate.departureDate);

    this.daysMissing = [];

    let currentDate = payloadDateInitial.clone();

    while (currentDate.isBefore(payloadDateFinal) && this.daysMissing.length < 7) {
      this.daysMissing.push(currentDate.format("ddd"));
      currentDate.add(1, "days");
    }

    if (this.daysMissing.length != 7) {
      this.daysMissing.push(payloadDateFinal.format("ddd"));
    }
  }

  /**
   * Del dato que viene del tour de zoco obtener el nodo de amenities.
   * validar mediante el nodo de details de amenities y verificar si trae un traslado.
   */
  getAmenitiesTransfer() {
    if (this.tour?.additionalInfo.tours?.options[0]?.amenties) {
      this.tour.additionalInfo.tours?.options[0]?.amenties?.forEach((amenitie: any) => {
        if (amenitie.details.require_transfer === 1) {
          this.valuePriceTypeTransfer = amenitie.totalPrice;
          this.requireTransfer = true;
        } else {
          this.requireTransfer = false;
          this.disabledOption = true;
        }
      });
    } else {
      this.requireTransfer = false;
      this.disabledOption = true;
    }
  }

  transferPrivacy(event: any) {
    if (event == true) {
      this.disabledOption = false;
    } else {
      this.disabledOption = true;
      this.transferTypeValue = null;
    }
  }

  transferType(event: any) {
    if (event == "Regular") {
      this.valuePriceTypeTransfer = 20;
    } else {
      this.valuePriceTypeTransfer = 30;
    }
  }

  _openModal(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleCheckInReq(): void {
    this.isCollapsedCheckInReq = !this.isCollapsedCheckInReq;
  }

  toggleCheckInObs(): void {
    this.isCollapsedCheckInObs = !this.isCollapsedCheckInObs;
  }


    /**
 * Confirma la selección y actualiza el estado de la UI
 *
 * Este método maneja la acción de confirmación, colapsando la UI de selección
 * y activando las validaciones, además de actualizar la visualización de rooms/passengers.
 *
 * @returns {void}
 *
 * @stateChanges
 * - isCollapsed: false → Muestra el contenido confirmado
 * - validate: true → Activa el estado de validación
  *
 * @usage
 * Llamado cuando el usuario confirma su selección de habitaciones/pasajeros
 */
  _confirmAdult() {
    this.isCollapsedAdult = false;
    // this.setRoomAndPassanger();
  }

      /**
 * Confirma la selección y actualiza el estado de la UI
 *
 * Este método maneja la acción de confirmación, colapsando la UI de selección
 * y activando las validaciones, además de actualizar la visualización de rooms/passengers.
 *
 * @returns {void}
 *
 * @stateChanges
 * - isCollapsed: false → Muestra el contenido confirmado
 * - validate: true → Activa el estado de validación
  *
 * @usage
 * Llamado cuando el usuario confirma su selección de habitaciones/pasajeros
 */
  _confirmChild() {
    this.isCollapsedChild = false;
    // this.setRoomAndPassanger();
  }

    /**
 * Maneja el evento de clic fuera del área de selección
 *
 * Este método se ejecuta cuando se detecta un clic fuera del área
 * de selección de habitaciones/pasajeros, confirmando la selección actual.
 *
 * @param {any} event - Objeto evento del clic
 * @returns {void}
 *
 * @actions
 * - setRoomAndPassanger(): Actualiza la visualización con la selección actual
 *
 * @usage
 * Mejora la UX al confirmar automáticamente al hacer clic fuera del modal
 */
  clickOutside(event: any) {
    // this.setRoomAndPassanger();
  }


  /**
   * Valida la categoria segun el categorieId para cambiar el nombre el la tabs.
   * @returns retorna el nombre de la categoria.
   */
  categorieSubCategoryName() {
    const categoryId = this.payload?.[0]?.categoriesId?.[0];
    switch (categoryId) {
      case 6:
        return "EXPERIENCIA";
        break;
      case 9:
        return "TICKETS";
        break;
      default:
        return "default";
        break;
    }
  }

  getComments(): void {
    const params = `/cruds/comments/by-product/${this.tour.productId}?booking_agency_id=${this.userService?._agencyID}&booking_agent_id=${this.userService?._agentID}&client_id=${this.clientSetting.id}`;
    this._restService.doGet("api", params).subscribe({
      next: (res: any) => {
        // if(res.status === 'success') {
        this.comments = res.list;
        // this.commentsAgent = res.edits;
        // }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }

/**
 * Procesa y organiza los precios por tipo de pasajero obtenidos de las opciones de tour,
 * separándolos en categorías de adultos y niños basándose en la edad mínima del adulto
 */
getPaxPricesType(): void {
  const allTypePaxPrices: any[] = [];

  this.optionsTour.forEach((option: any) => {
    if (option.paxPrices && Array.isArray(option.paxPrices)) {
      allTypePaxPrices.push(...option.paxPrices);
    }
  });

  // Eliminar duplicados basándose en paxType, ageFrom y ageTo
  const uniquePaxPrices = Array.from(
    new Map(
      allTypePaxPrices.map((pax: any) => [
        `${pax.paxType}-${pax.ageFrom}-${pax.ageTo}`,
        pax
      ])
    ).values()
  );

  // Ordenar por edad mínima (ageFrom) de menor a mayor
  const sortedPaxPrices = uniquePaxPrices.sort((a: any, b: any) =>
    a.ageFrom - b.ageFrom
  );

  // Encontrar la configuración de edad para adultos
  const paxAdultsAges = sortedPaxPrices.find((pax: any) => pax.paxType === 'ADULT');

  // Separar en arrays de adultos y niños basándose en la edad mínima del adulto
  const paxAdultsAgesArr = sortedPaxPrices.filter((pax: any) =>
    pax.ageFrom >= paxAdultsAges.ageFrom
  );

  const paxChildsAgesArr = sortedPaxPrices.filter((pax: any) =>
    pax.ageFrom < paxAdultsAges.ageFrom
  );

  this.paxAdultsAgeArr = paxAdultsAgesArr;
  this.paxChildsAgesArr = paxChildsAgesArr;

}

getOptionsGroupName(): void {
  const allLanguages = this.optionsTour.map((option: any) => option.option_name) || [];

}

getLanguageGuide(optionTour): any[] {

  // Primero filtrar opciones que coinciden con el mismo option_name
  const sameNameOptions = this.tour.additionalInfo.tours.options.filter(opt =>
    (opt.option_name || opt.name) === (optionTour.option_name || optionTour.name)
  );

  const allLanguages = sameNameOptions
    .map(opt => opt.language)
    .filter(lang => lang); // eliminar null/undefined

  // Devolver valores únicos
  return [...new Set(allLanguages)];
}

  /**
 * Obtiene y ordena las horas disponibles para tickets de tours
 *
 * Esta función extrae las sesiones horarias de las opciones de tour disponibles
 * y las ordena cronológicamente de menor a mayor (mañana a tarde) para
 * facilitar la selección por parte del usuario.
 *
 * @returns {void}
 *
 * @example
 * // Si this.optionsTour contiene:
 * // [{ sessions: '14:00' }, { sessions: '09:00' }]
 * // Resultado: this.hoursAvailable = ['09:00', '14:00']
 *
 * @description
 * El proceso realiza las siguientes operaciones:
 * 1. Extrae las sesiones de cada opción de tour usando map()
 * 2. Convierte cada hora string a minutos totales para comparación numérica
 * 3. Ordena las horas mediante comparación de minutos totales
 * 4. Almacena el resultado ordenado en this.hoursAvailable
 *
 * La conversión a minutos totales asegura un ordenamiento preciso
 * incluso cuando las horas incluyen minutos diferentes de '00'
 */
getHoursAvailTickets(optionTour): any[] {
  // Filtrar opciones con el mismo nombre
  const sameNameOptions = this.tour.additionalInfo.tours.options.filter(opt =>
    (opt.option_name || opt.name) === (optionTour.option_name || optionTour.name)
  );

  // Extraer todas las sesiones (son strings)
  const allSessions: string[] = [];

  for (const opt of sameNameOptions) {
    if (opt.sessions && typeof opt.sessions === 'string') {
      allSessions.push(opt.sessions);
    }
  }

  // Si no hay sesiones, usar scheduling como fallback
  if (allSessions.length === 0 && this.tour.scheduling?.[0]?.opened) {
    for (const schedule of this.tour.scheduling[0].opened) {
      if (schedule.openingTime) {
        allSessions.push(schedule.openingTime);
      }
    }
  }

  // Eliminar duplicados usando Set
  const uniqueSessions = [...new Set(allSessions)];

  // Ordenar
  return uniqueSessions.sort((a: string, b: string) => {
    const [hoursA, minutesA] = a.split(':').map(Number);
    const [hoursB, minutesB] = b.split(':').map(Number);

    const totalMinutesA = hoursA * 60 + (minutesA || 0);
    const totalMinutesB = hoursB * 60 + (minutesB || 0);

    return totalMinutesA - totalMinutesB;
  });
}


  moreDescription(): void {
    this.tab = 'info';
    setTimeout(() => {
         this.openInfoDescription = true;
    }, 100);
  }

  // Estado de expansión por card para los placeholders de "Completa tu viaje".
  // Cuando se monte el *ngFor, la key puede pasar a ser item.id sin tocar la lógica.
  private expandedDescriptions: { [key: string]: boolean } = {};

  toggleDescription(cardId: string): void {
    this.expandedDescriptions[cardId] = !this.expandedDescriptions[cardId];
  }

  isDescriptionExpanded(cardId: string): boolean {
    return !!this.expandedDescriptions[cardId];
  }

  activeMediaIndex: number = 1;
  activeMedia: { type: 'image' | 'video'; src: string } | null = null;

  mockMedia: { type: 'image' | 'video'; src: string }[] = [
    { type: 'video', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4' },
    { type: 'image', src: 'assets/img/sin-logo.png' },
  ];

  /** Videos que se ofrecen como media del tour. */
  get videoItems(): { type: 'video'; src: string }[] {
    const fromBackend = this.tour?.additionalInfo?.videos;
    if (fromBackend?.length) {
      return fromBackend
        .map((v: any) => ({ type: 'video' as const, src: v.src || v.url || v.thumbnail || '' }))
        .filter((v: { src: string }) => !!v.src);
    }
    return this.mockMedia.filter((m) => m.type === 'video') as { type: 'video'; src: string }[];
  }

  /** Imágenes que se ofrecen como media del tour. Caen al mock solo si NO hay imágenes de galería. */
  get imageItems(): { type: 'image'; src: string }[] {
    const galleryImages: { type: 'image'; src: string }[] = (this.tour?.additionalInfo?.images || [])
      .filter((img: any) => img?.thumbnail)
      .map((img: any) => ({ type: 'image' as const, src: img.thumbnail }));
    if (galleryImages.length) return galleryImages;
    return this.mockMedia.filter((m) => m.type === 'image') as { type: 'image'; src: string }[];
  }

  /**
   * Ítems que se muestran como BOTONES en el overlay inferior del banner.
   *
   * El banner tiene 3 slots fijos que se llenan con `images` (hero + 2
   * laterales). Los videos no tienen slot fijo propio, así que viven acá:
   * cada botón del overlay representa un video disponible y al clickearlo
   * se reemplaza el contenido del slot 2.
   *
   * Si no hay videos del backend, devuelve `[]` para que el overlay no
   * aparezca (el banner muestra solo imágenes en sus slots fijos).
   */
  get allMediaItems(): { type: 'image' | 'video'; src: string; disabled: boolean }[] {
    return [
      {
        src: '',
        type: 'video',
        disabled: true,
      },
      {
        src: '',
        type: 'image',
        disabled: false,
      },
    ];
  }

  selectMedia(index: number, isDisabled: boolean): void {
    if(isDisabled) {
      this.notificationService.warning('No se tienen videos para esta experiencia');
    } else {
      this.activeMediaIndex = index;
      this.activeMedia = this.allMediaItems[index] ?? null;
    }
  }

  // Lightbox con dos modos: imagen o video.
  lightboxOpen = false;
  lightboxKind: 'image' | 'video' | null = null;
  lightboxIndex = 0;

  openImageLightbox(i: number): void {
    this.lightboxKind = 'image';
    this.lightboxIndex = i;
    this.lightboxOpen = true;
  }

  openVideoLightbox(i: number): void {
    this.lightboxKind = 'video';
    this.lightboxIndex = i;
    this.lightboxOpen = true;
  }

  /** Helper para el template: devuelve el array activo según lightboxKind. */
  get activeLightboxItems(): { type: 'image' | 'video'; src: string }[] {
    return this.lightboxKind === 'video' ? this.videoItems : this.imageItems;
  }

  closeLightbox(event?: Event): void {
    if (event && event.target !== event.currentTarget) return;
    this.lightboxOpen = false;
    this.lightboxKind = null;
  }

  lightboxPrev(_event?: Event): void {
    const items = this.activeLightboxItems;
    if (!items.length) return;
    this.lightboxIndex = (this.lightboxIndex - 1 + items.length) % items.length;
  }

  lightboxNext(_event?: Event): void {
    const items = this.activeLightboxItems;
    if (!items.length) return;
    this.lightboxIndex = (this.lightboxIndex + 1) % items.length;
  }

  // Cantidad seleccionada para cada opcional extra (incrementa/decrementa con los botones +/-).
  // La key es única por item: descripción + índice del array.
  private addonsQuantities: { [key: string]: number } = {};

  getAddonQty(key: string): number {
    return this.addonsQuantities[key] ?? 0;
  }

  incrementAddon(key: string): void {
    this.addonsQuantities[key] = this.getAddonQty(key) + 1;
  }

  decrementAddon(key: string): void {
    const current = this.getAddonQty(key);
    this.addonsQuantities[key] = current > 0 ? current - 1 : 0;
  }

  // Handlers para los contadores hardcodeados de "Ticket de Ingreso" y "Tour Relacionado".
  incTicket(optionId: string): void {
    this.ticketQty[optionId] = (this.ticketQty[optionId] || 0) + 1;
  }

  decTicket(optionId: string): void {
    this.ticketQty[optionId] = Math.max(0, (this.ticketQty[optionId] || 0) - 1);
  }

  getEntryTicket(option: any): any {
    return option?.entryTicket?.tickets?.[0];
  }

  getEntryTicketImage(option: any): string {
    const images = this.getEntryTicket(option)?.images;
    if (Array.isArray(images) && images.length) {
      const cover = images.find((img: any) => img?.isCover) || images[0];
      return cover?.image || cover?.thumbnail;
    }
    return '';
  }

  getEntryTicketName(option: any): string {
    const ticket = this.getEntryTicket(option);
    return ticket?.name || ticket?.productName || 'Ticket';
  }

  incTourRelated(optionId: string): void {
    this.tourRelatedQty[optionId] = (this.tourRelatedQty[optionId] || 0) + 1;
  }

  decTourRelated(optionId: string): void {
    this.tourRelatedQty[optionId] = Math.max(0, (this.tourRelatedQty[optionId] || 0) - 1);
  }

  getRelatedTour(option: any): any {
    return option?.relatedTours?.[0];
  }

  getRelatedTourImage(option: any): string {
    const images = this.getRelatedTour(option)?.images;
    if (Array.isArray(images) && images.length) {
      const cover = images.find((img: any) => img?.isCover) || images[0];
      return cover?.image || cover?.thumbnail;
    }
    return '';
  }

  getRelatedTourName(option: any): string {
    const rTour = this.getRelatedTour(option);
    return rTour?.name || rTour?.productName || rTour?.title || 'Tour';
  }



periodsActivities(options: any): string {

      switch (this.payload[0]?.categoriesId[0]) {
        case 6:
           return this.getPeriodsArr(options);
        case 9:
            return this.getPeriodsArr(options);
          //  const languages = this.getLanguageArray(options);
          //  return languages.join(', ');
          break;
        default:
          break;
      }
  }
/**
 * Procesa y formatea los periodos del día basados en las sesiones disponibles,
 * eliminando duplicados y ordenándolos cronológicamente
 * @param options - Array de objetos con información de tours/actividades
 * @returns String con periodos únicos ordenados separados por comas
 */
getPeriodsArr(options: any): string {
  if (!options || !Array.isArray(options)) {
    return '';
  }

  const periodsSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.sessions) {
      const sessions = Array.isArray(option.sessions)
        ? option.sessions
        : [option.sessions];

      sessions.forEach((session: string) => {
        if (session && typeof session === 'string') {
          const period = this.getTimePeriod(session);
          if (period) {
            periodsSet.add(period);
          }
        }
      });
    }
  });

  // Ordenar los periodos: mañana, tarde, noche
  const periodOrder: { [key: string]: number } = {
    'mañana': 1,
    'tarde': 2,
    'noche': 3
  };

  const periodsArray = Array.from(periodsSet).sort((a: string, b: string) =>
    periodOrder[a] - periodOrder[b]
  );

  return periodsArray.join(`${periodsArray.length > 1 ? ' y la ' : ' y '}`);
}

/**
 * Determina el periodo del día (mañana, tarde, noche) basado en la hora
 * @param timeString - Hora en formato "HH:MM" (ej: "14:30")
 * @returns String con el periodo del día correspondiente
 */
getTimePeriod(timeString: string): string {
  try {
    const [hours, minutes] = timeString.split(':').map((part: string) => Number(part));

    if (isNaN(hours) || isNaN(minutes)) {
      return 'mañana';
    }

    if (hours < 12) {
      return 'mañana';
    } else if (hours < 19) {
      return 'tarde';
    } else {
      return 'noche';
    }
  } catch (error) {
    return 'mañana';
  }
}

getDurations(options: any): string {
     switch (this.payload[0]?.categoriesId[0]) {
        case 6:
           return this.getDurationsArr(options);
        case 9:
          //  const languages = this.getLanguageArray(options);
          //  return languages.join(', ');
          break;
        default:
          return '';
    }
}

/**
 * Procesa y formatea las duraciones disponibles en las opciones,
 * eliminando duplicados y retornando un string formateado
 * @param options - Array de objetos con información de tours/actividades
 * @returns String con duraciones únicas formateadas separadas por comas
 */
getDurationsArr(options: any): string {
  if (!options || !Array.isArray(options)) {
    return '';
  }

  const durationsSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.duration) {
      const durations = Array.isArray(option.duration)
        ? option.duration
        : [option.duration];

      durations.forEach((duration: string) => {
        if (duration && typeof duration === 'string') {
          const formattedDuration = this.builderDuration(duration);
          if (formattedDuration) {
            durationsSet.add(formattedDuration);
          }
        }
      });
    }
  });

  const durationsArray = Array.from(durationsSet);
  return durationsArray.join(', ');
}

/**
 * Convierte un string de duración en formato técnico a formato legible
 * @param timeString - Duración en formato "valor-tipo" (ej: "1-DAYS")
 * @returns String formateado para mostrar al usuario
 */
builderDuration(timeString: string): string {
  try {
    const parts = timeString.split('-').map((part: string) => part.trim());

    if (parts.length !== 2) {
      return 'N/A';
    }

    const value = parseInt(parts[0], 10);
    const type = parts[1].toUpperCase();

    if (isNaN(value)) {
      return 'N/A';
    }

    if (type === 'DAYS') {
      if (value === 1) {
        return '1 día';
      } else {
        return `${value} días`;
      }
    } else if (type === 'HOURS') {
      return `${value} minutos`;
    } else {
      return `${value} ${type}`;
    }
  } catch (error) {
    return 'N/A';
  }
}

/**
 * Obtiene los idiomas disponibles formateados como string separado por comas
 * @param options - Array de objetos con información de tours/actividades
 * @returns String con idiomas únicos separados por comas
 */
getLanguages(options: any): string {
  const languages = this.getLanguageArray(options);
  return languages.join(', ');
}

/**
 * Extrae y retorna un array con los idiomas únicos disponibles en las opciones
 * @param options - Array de objetos con información de tours/actividades
 * @returns Array de strings con idiomas únicos
 */
getLanguageArray(options: any): string[] {
  if (!options || !Array.isArray(options)) {
    return [];
  }

  const languagesSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.language) {
      if (Array.isArray(option.language)) {
        option.language.forEach((lang: string) => {
          languagesSet.add(lang);
        });
      } else {
        languagesSet.add(option.language);
      }
    }
  });

  return Array.from(languagesSet);
}

getGuideAmenity(amenities: any[]): string {
  if (!amenities || amenities.length === 0) {
    return '';
  }

  const matches = new Set<string>();

  amenities.forEach((amenity: any) => {
    if (amenity.description) {
      const desc = amenity.description.toLowerCase();

      const iconPatterns = [
        { pattern: /(guía|guia|guide)/, text: 'con guía' },
        { pattern: /(auriculares)/, text: 'con auriculares' },
        { pattern: /(audioguia|audioguía)/, text: 'con audioguía' }
      ];

      const matchedPattern = iconPatterns.find(item => item.pattern.test(desc));

      if (matchedPattern) {
        matches.add(matchedPattern.text);
      }
    }
  });

  const matchString = Array.from(matches).join(' y en ');
  return matchString ? `${matchString} en ` : 'en ';
}

getDate(date: any): string {
  if (!date) return 'Fecha no válida';

  moment.locale('es');
  let parsedDate = moment(date, 'YYYY-MM-DD', true); // Para formato ISO

  if (!parsedDate.isValid()) {
    // Intentar con otro formato si el primero falla
    parsedDate = moment(date, 'EE dd MM, YYYY', 'es', true);
  }

  if (!parsedDate.isValid()) {
    console.error('Fecha inválida:', date);
    return 'Fecha inválida';
  }

  return parsedDate.format('DD [de] MMMM [de] YYYY');
}

// // Definir un mapping de tipos de pasajeros a propiedades del payload
// private readonly paxTypeToPayloadMap: { [key: string]: string } = {
//     'ADULT': 'adults',
//     'CHILD': 'children',
//     'INFANT': 'infants',
//     'SENIOR': 'seniors',
//     'STUDENT': 'students',
//     'YOUTH': 'youths'
// };

// private initializePassengerCounts(): void {
//     const paxPrices = this.optionsTour[0].paxPrices;
//     const payloadTours = this.payloadUpdate?.others?.tours || {};

//     this.passengerCounts = paxPrices.map(price => {
//         const paxType = price.paxType;

//         // 1. Buscar en el mapping
//         const payloadKey = this.paxTypeToPayloadMap[paxType];
//         if (payloadKey && payloadTours[payloadKey] !== undefined) {
//             // Para CHILD, necesitamos filtrar por edades
//             if (paxType === 'CHILD') {
//                 const childAges = payloadTours.children || [];
//                 return childAges.filter((age: number) =>
//                     age >= price.ageFrom && age <= (price.ageTo || 99)
//                 ).length;
//             }
//             return payloadTours[payloadKey];
//         }

//         // 2. Intentar con versión en minúscula + 's'
//         const fallbackKey = `${paxType.toLowerCase()}s`;
//         if (payloadTours[fallbackKey] !== undefined) {
//             return payloadTours[fallbackKey];
//         }

//         // 3. Si es CHILD pero no está en el mapping (por si acaso)
//         if (paxType === 'CHILD') {
//             const childAges = payloadTours.children || [];
//             return childAges.filter((age: number) =>
//                 age >= price.ageFrom && age <= (price.ageTo || 99)
//             ).length;
//         }

//         // 4. Valor por defecto
//         return 0;
//     });

//     // Determinar índice mandatory (el que se usa para precio base)
//     this.indexPaxMandatory = this.findMandatoryPaxIndex(paxPrices);

//     this.onPassengerChange();
//     this.initializeChildAges();
// }

private findMandatoryPaxIndex(paxPrices: any[]): number {
    // Prioridad: ADULT > ADULTS > el de mayor edad > el primero
    const adultIndex = paxPrices.findIndex(c =>
        c.paxType === 'ADULT' || c.paxType === 'ADULTS'
    );
    if (adultIndex !== -1) return adultIndex;

    // Buscar el de mayor rango de edad (probablemente el precio base)
    let maxAgeIndex = -1;
    let maxAgeFrom = -1;
    paxPrices.forEach((price, index) => {
        if (price.ageFrom > maxAgeFrom) {
            maxAgeFrom = price.ageFrom;
            maxAgeIndex = index;
        }
    });
    if (maxAgeIndex !== -1) return maxAgeIndex;

    // Fallback: el primero que tenga amount > 0
    return paxPrices.findIndex(c => c.amount > 0);
}

/**
 * Inicializa el array de childAges basado en el payload
 */
private initializeChildAges(): void {
  this.childAges = this.payloadUpdate?.others?.tours?.children || [];
}

/**
 * Obtiene el contador de pasajeros para un índice específico
 */
getPassengerCount(index: number): number {
    return this.passengerCounts[index] || 0;
}

/**
 * Obtiene el máximo de pasajeros permitido para un índice específico
 */
getMaxPassengers(index: number): number {
    // Lógica personalizada según el tipo de pasajero
    const passengerType = this.optionsTour[0].paxPrices[index]?.paxType;
    return passengerType === 'ADULT' ? 10 : 5; // Máximos diferentes
}

getSumPaxOptionTickets(option: any): number {

  if(option.paxPrices && option.paxPrices.length > 0) {
    return option.profility.find(c => c.paxType === 'ADULT').netPriceBooking;
  }

  return 0;
}

/**
 * Obtiene el precio (amountProf) correspondiente al tipo de pasajero asignado
 */
getPriceForPaxTypeTicket(ticket: any): number {
  if (!ticket.paxType || !ticket.paxPrices || !ticket.prices) {
    return 0;
  }

  // Encontrar el índice en paxPrices que coincide con el paxType asignado
  const paxPriceIndex = ticket.paxPrices.findIndex((paxPrice: any) =>
    paxPrice.paxType === ticket.paxType.type
  );

  // Si encontramos el índice, buscar el price correspondiente en el mismo índice
  if (paxPriceIndex !== -1 && ticket.prices[paxPriceIndex]) {
    const price = ticket.prices[paxPriceIndex];
    return Number(price.amountProf) || Number(price.amount) || 0;
  }

  // Si no encontramos por índice, buscar por tipo
  const matchingPrice = ticket.prices.find((price: any) =>
    price.paxType === ticket.paxType.type
  );

  if (matchingPrice) {
    return Number(matchingPrice.amountProf) || Number(matchingPrice.amount) || 0;
  }

  return 0;
}

// En tu componente

// Mapeo dinámico de tipos de pasajeros
private paxTypeToPayloadMap: { [key: string]: string } = {
    'ADULT': 'adults',
    'CHILD': 'children',
    'INFANT': 'infants',
    'SENIOR': 'seniors',
    'STUDENT': 'students',
    'YOUTH': 'youths'
};

// Almacenar edades por tipo de pasajero
// Almacenar la cantidad mínima por tipo de pasajero (la que vino de la búsqueda)
private minCountsByPaxType: { [paxType: string]: number } = {};
private agesByPaxType: { [paxType: string]: number[] } = {};

private initializePassengerCounts(): void {
    const paxPrices = this.optionsTour[0].paxPrices;
    const payloadTours = this.payloadUpdate?.others?.tours || {};
    // Inicializar el almacen de edades por tipo
    this.agesByPaxType = {};
    this.minCountsByPaxType = {};

    this.passengerCounts = paxPrices.map(price => {
        const paxType = price.paxType;
        const requiresAge = this.paxTypeRequiresAge(paxType);

        // Inicializar array de edades
        if (!this.agesByPaxType[paxType]) {
            this.agesByPaxType[paxType] = [];
        }

        let count = 0;
        let minCount = 0;

        // Buscar según el tipo
        if (paxType === 'ADULT') {
            // Adultos: usar payloadTours.adults
            count = payloadTours.adults || 0;
            minCount = count; // No se puede bajar de la cantidad inicial
        }
        else if (paxType === 'CHILD') {
            // Niños: usar payloadTours.children (array de edades)
            const childAges = payloadTours.children || [];
            // Filtrar edades que están en el rango
            const agesInRange = childAges.filter((age: number) =>
                Number(age) >= Number(price.ageFrom) && Number(age) <= Number(price.ageTo || 99)
            );
            this.agesByPaxType[paxType] = [...agesInRange];
            count = agesInRange.length;
            minCount = count; // No se puede bajar de la cantidad inicial
        }
        else if (paxType === 'INFANT') {
            // Infantes: usar payloadTours.infants (array de edades)
            const infantAges = payloadTours.children || [];
            const agesInRange = infantAges.filter((age: number) =>
               Number(age) >= Number(price.ageFrom) && Number(age) <= Number(price.ageTo || 99)
            );
            this.agesByPaxType[paxType] = [...agesInRange];
            count = agesInRange.length;
            minCount = count;
        }
        else if(paxType !== 'ADULT' && paxType !== 'CHILD' && paxType !== 'INFANT') {
            // Otros tipos (SENIOR, STUDENT, etc.) se suman a adultos?
            // O se manejan con su propia propiedad en minúscula + 's'
            const fallbackKey = `${paxType.toLowerCase()}s`;
            if (payloadTours[fallbackKey] !== undefined) {
                if (requiresAge) {
                    const ages = payloadTours[fallbackKey] || [];
                    const agesInRange = ages.filter((age: number) =>
                       Number(age) >= Number(price.ageFrom) && Number(age) <= Number(price.ageTo || 99)
                    );
                    this.agesByPaxType[paxType] = [...agesInRange];
                    count = agesInRange.length;
                } else {
                    count = payloadTours[fallbackKey] || 0;
                }
            } else {
                // Si no tiene propiedad específica, sumar a adultos o usar 0
                count = 0;
            }
            minCount = count;
        }

        // Guardar el mínimo permitido para este índice/paxType
        this.minCountsByPaxType[paxType] = minCount;

        return count;
    });
    this.indexPaxMandatory = this.findMandatoryPaxIndex(paxPrices);
    this.onPassengerChange();
    this.initializeChildAges();
}



/**
 * Obtiene el mínimo permitido para un tipo de pasajero
 */
getMinCountForPaxType(paxType: string): number {
    return this.minCountsByPaxType[paxType] || 0;
}

/**
 * Obtiene el mínimo para un índice específico
 */
getMinCountForIndex(index: number): number {
    const paxType = this.optionsTour[0].paxPrices[index]?.paxType;
    return paxType ? this.getMinCountForPaxType(paxType) : 0;
}
/**
 * Determina si un tipo de pasajero requiere ingresar edades
 */
public paxTypeRequiresAge(paxType: string): boolean {
    const typesThatRequireAge = ['CHILD', 'INFANT', 'YOUTH', 'SENIOR'];
    return typesThatRequireAge.includes(paxType);
}

/**
 * Incrementa pasajero (dinámico) - CORREGIDO
 */
incrementPassenger(index: number, paxPrice?: any): void {
    if (this.passengerCounts[index] < this.getMaxPassengers(index)) {
        const priceCount = this.optionsTour[0].paxPrices[index];
        const paxType = priceCount.paxType;

        // Crear nuevo array
        this.passengerCounts = [
            ...this.passengerCounts.slice(0, index),
            this.passengerCounts[index] + 1,
            ...this.passengerCounts.slice(index + 1)
        ];

        // Si requiere edad, agregar edad por defecto (edad mínima del rango)
        if (this.paxTypeRequiresAge(paxType)) {
            if (!this.agesByPaxType[paxType]) {
                this.agesByPaxType[paxType] = [];
            }
            const defaultAge = priceCount.ageFrom;
            this.agesByPaxType[paxType] = [
                ...this.agesByPaxType[paxType],
                defaultAge
            ];
        }

        // Lógica para tickets (categoría 9)
        if (this.payload[0].categoriesId[0] === 9) {
            // ✅ Pasar el índice para obtener la edad correcta después
            this.addNewPassengerToAvailable(paxPrice, index);
        }

        this.onPassengerChange();
        this.checkAvailProduct();
    }
}

/**
 * Agrega un nuevo pasajero a availablePassengers - CORREGIDO PARA ADULTOS
 */
private addNewPassengerToAvailable(paxPrice: any, index: number): void {
    const priceCount = this.optionsTour[0].paxPrices[index];
    const paxType = priceCount.paxType;

    // ✅ Obtener la edad (si aplica)
    let newAge: number | null = null;

    if (this.paxTypeRequiresAge(paxType)) {
        const agesForType = this.agesByPaxType[paxType] || [];
        newAge = agesForType[agesForType.length - 1];
    }

    // ✅ CRÍTICO: Para adultos, NO buscar existentes
    // Los adultos son intercambiables, siempre hay que agregar uno nuevo
    if (paxType === 'ADULT') {
        // No validar existencia, agregar directamente
        const currentAdultCount = this.availablePassengers.filter(p => p.type === 'ADULT').length;
        const newId = `ADULT_${currentAdultCount + 1}_${Date.now()}`;

        const newPassenger = {
            type: 'ADULT',
            ageRange: { from: priceCount.ageFrom, to: priceCount.ageTo },
            age: null,
            id: newId
        };

        this.availablePassengers.push(newPassenger);
        return;
    }

    // ✅ Para CHILD, INFANT, SENIOR: validar que no exista la misma edad
    let existingPassenger: any = null;
    for (const passenger of this.availablePassengers) {
        if (passenger.type === paxType && passenger.age === newAge && !this.isPassengerAlreadyAssignedToAnyTicket(passenger)) {
            existingPassenger = passenger;
            break;
        }
    }

    if (existingPassenger) {
        return;
    }

    // Generar ID para no-adultos
    const currentCountForType = this.availablePassengers.filter(p => p.type === paxType).length;
    const newId = `${paxType}_${currentCountForType + 1}_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;

    const newPassenger = {
        type: paxType,
        ageRange: { from: priceCount.ageFrom, to: priceCount.ageTo },
        age: newAge,
        id: newId
    };

    this.availablePassengers.push(newPassenger);
}

/**
 * Verifica si un pasajero ya está asignado a algún ticket
 */
private isPassengerAlreadyAssignedToAnyTicket(passenger: any): boolean {
    for (const ticket of this.ticketsSelected) {
        if (ticket.assignedPassengers && ticket.assignedPassengers.length > 0) {
            const exists = ticket.assignedPassengers.some((p: any) => p.id === passenger.id);
            if (exists) return true;
        }
    }
    return false;
}



/**
 * Decrementa pasajero (dinámico)
 */
decrementPassenger(index: number, paxPrice?: any): void {
    const priceCount = this.optionsTour[0].paxPrices[index];
    const paxType = priceCount.paxType;
    const minCount = this.getMinCountForIndex(index);
    const currentCount = this.passengerCounts[index];

    if (currentCount <= minCount) {
        this.notificationService?.warning(`No se puede reducir menos de ${minCount} ${this.getPaxTypeMessage(paxType)}`);
        return;
    }

    if (index === this.indexPaxMandatory && currentCount <= 1) {
        return;
    }

    if (currentCount > 0) {
        // ✅ SI HAY TICKETS SELECCIONADOS, PREGUNTAR ANTES DE DECREMENTAR
        if (this.payload[0].categoriesId[0] === 9 && this.ticketsSelected.length > 0) {
            const confirmReset = confirm(
                `Al reducir la cantidad de ${this.getPaxTypeMessage(paxType)}s, los tickets ya seleccionados se perderán. ¿Deseas continuar?`
            );
            if (!confirmReset) {

                return;
            }
        }

        this.passengerCounts = [
            ...this.passengerCounts.slice(0, index),
            currentCount - 1,
            ...this.passengerCounts.slice(index + 1)
        ];

        if (this.paxTypeRequiresAge(paxType) && this.agesByPaxType[paxType]?.length > 0) {
            this.agesByPaxType[paxType] = this.agesByPaxType[paxType].slice(0, -1);
        }

        // ✅ SOLO CUANDO SE DECREMENTA: resetear tickets
        if(this.payload[0].categoriesId[0] === 9) {
            this.resetTickets();
        }

        this.onPassengerChange();
        this.checkAvailProduct();
    }
}

/**
 * Resetea todos los tickets seleccionados y las asignaciones
 */
resetTickets(): void {
    // Limpiar tickets seleccionados
    this.ticketsSelected = [];

    // Regenerar availablePassengers basado en los nuevos passengerCounts
    this.regenerateAvailablePassengersFromAges();
    // Limpiar tooltips
    this.showDeleteTooltip = [];

    // Resetear el mat-select
    if (this.mySelect) {
        this.mySelect.value = [];
    }

    // Resetear variable de control
    this.createNewPaxSelectedTicket = true;

    this.notificationService.info('Los tickets han sido reiniciados debido a cambios en la cantidad de pasajeros');
}

/**
 * Regenera la lista de pasajeros disponibles basado en los passengerCounts actuales
 */
regenerateAvailablePassengers(): void {
    this.availablePassengers = [];

    const paxPrices = this.optionsTour[0]?.paxPrices || [];

    for (let i = 0; i < paxPrices.length; i++) {
        const price = paxPrices[i];
        const count = this.passengerCounts[i] || 0;
        const paxType = price.paxType;

        for (let j = 0; j < count; j++) {
            this.availablePassengers.push({
                type: paxType,
                ageRange: { from: price.ageFrom, to: price.ageTo },
                age: paxType === 'ADULT' ? null : price.ageTo,
                id: `${paxType}_${j}_${Date.now()}_${Math.random()}`
            });
        }
    }

}

/**
 * Obtiene inputs de edad para cualquier tipo que requiera edad
 */
getAgeInputs(paxIndex: number): any[] {
    const priceCount = this.optionsTour[0].paxPrices[paxIndex];
    const paxType = priceCount.paxType;

    if (this.paxTypeRequiresAge(paxType)) {
        const agesInRange = this.agesByPaxType[paxType]?.filter(age =>
            age >= priceCount.ageFrom && age <= (priceCount.ageTo || 99)
        ) || [];
        return Array(agesInRange.length).fill(0);
    }
    return [];


}


/**
 * Obtiene la edad para un índice específico
 */
getAgeForRange(paxIndex: number, ageIndex: number): number {
    const priceCount = this.optionsTour[0].paxPrices[paxIndex];
    const paxType = priceCount.paxType;

    if (this.paxTypeRequiresAge(paxType)) {
        const agesInRange = this.agesByPaxType[paxType]?.filter(age =>
            age >= priceCount.ageFrom && age <= (priceCount.ageTo || 99)
        ) || [];

        return agesInRange[ageIndex] || priceCount.ageFrom;
    }
    return 0;
}

/**
 * Regenera availablePassengers desde cero basado en agesByPaxType
 * Esta es la única función que necesitas para mantener sincronizado
 */
regenerateAvailablePassengersFromAges(): void {
    if (this.payload[0].categoriesId[0] !== 9) {
        return;
    }

    this.availablePassengers = [];
    const paxPrices = this.optionsTour[0].paxPrices;

    for (let i = 0; i < paxPrices.length; i++) {
        const price = paxPrices[i];
        const paxType = price.paxType;
        const count = this.passengerCounts[i] || 0;

        if (count > 0) {
            if (this.paxTypeRequiresAge(paxType)) {
                // Para niños/infantes: usar las edades de agesByPaxType
                const ages = this.agesByPaxType[paxType] || [];
                for (let j = 0; j < ages.length; j++) {
                    this.availablePassengers.push({
                        type: paxType,
                        ageRange: { from: price.ageFrom, to: price.ageTo },
                        age: ages[j],
                        id: `${paxType}_${j}_${Date.now()}_${Math.random()}`
                    });
                }
            } else {
                // Para adultos: crear sin edad
                for (let j = 0; j < count; j++) {
                    this.availablePassengers.push({
                        type: paxType,
                        ageRange: { from: price.ageFrom, to: price.ageTo },
                        age: null,
                        id: `${paxType}_${j}_${Date.now()}_${Math.random()}`
                    });
                }
            }
        }
    }

}

/**
 * Actualiza edad en el rango
 */
updateAgeInRange(paxIndex: number, ageIndex: number, newAge: number): void {
    const priceCount = this.optionsTour[0].paxPrices[paxIndex];
    const paxType = priceCount.paxType;

    if (this.paxTypeRequiresAge(paxType) && !isNaN(newAge)) {
        // Obtener todas las edades de este tipo
        let allAges = [...(this.agesByPaxType[paxType] || [])];

        // Encontrar y actualizar la edad correcta
        let foundIndex = -1;
        let currentIndex = 0;

        for (let i = 0; i < allAges.length; i++) {
            const age = allAges[i];
            if (age >= priceCount.ageFrom && age <= (priceCount.ageTo || 99)) {
                if (currentIndex === ageIndex) {
                    foundIndex = i;
                    break;
                }
                currentIndex++;
            }
        }

        if (foundIndex !== -1) {
            allAges[foundIndex] = newAge;
            this.agesByPaxType[paxType] = allAges;

            // ✅ ÚNICA LLAMADA: regenerar availablePassengers
            this.regenerateAvailablePassengersFromAges();

            this.onPassengerChange();
        }
    }
}

/**
 * Devuelve las opciones válidas de edad para el paxIndex indicado.
 * Regla:下限 = priceCount.ageFrom (lo que ya viene del backend).
 * Tope: 18 años para niños, pero si el backend define un ageTo menor, se respeta.
 */
getAgeOptions(paxIndex: number): number[] {
    const priceCount = this.optionsTour[0].paxPrices[paxIndex];
    if (!priceCount) {
        return [];
    }
    const min = Number(priceCount.ageFrom) || 0;
    const backendMax = priceCount.ageTo ? Number(priceCount.ageTo) : Infinity;
    const max = Math.min(backendMax, 18);
    const options: number[] = [];
    for (let age = min; age <= max; age++) {
        options.push(age);
    }
    return options;
}

/**
 * Devuelve las edades actuales de los niños del paxIndex como string separado por comas,
 * para mostrar en el label "Edades de NIÑO (X, Y, Z)".
 */
getChildAgesLabel(paxIndex: number): string {
    const priceCount = this.optionsTour[0].paxPrices[paxIndex];
    if (!priceCount) {
        return '';
    }
    const paxType = priceCount.paxType;
    const agesInRange = (this.agesByPaxType[paxType] || []).filter(age =>
        age >= priceCount.ageFrom && age <= (priceCount.ageTo || 99)
    );
    return agesInRange.join(', ');
}

checkAvailProduct(): void {

  // this.tour.additionalInfo.tours?.options.forEach((option: any) => {
  //   let payload:any = this._payloadUpdateTours(this.form, this.tour, option);

  //   console.log(payload);

  //   payload["products"][0]["checkAvail"] = true;
  //   payload["products"][0]["market"] = 1;

  //   this._restService.doPost("app", "syncProducts", payload).subscribe({
  //     next: (res: any) => {
  //       console.log(res);
  //     },
  //     error: (error: HttpErrorResponse) => {

  //     }
  //   });

  // })
}

/**
 * Valida el input manual del usuario
 */
validatePassengerInput(event: any, index: number): void {
    const newValue = parseInt(event.target.value, 10);
    const max = this.getMaxPassengers(index);

    if (!isNaN(newValue) && newValue >= 0 && newValue <= max) {
        this.passengerCounts = [
            ...this.passengerCounts.slice(0, index),
            newValue,
            ...this.passengerCounts.slice(index + 1)
        ];
        this.onPassengerChange();
    } else {
        // Resetear al valor anterior si es inválido
        event.target.value = this.passengerCounts[index];
    }
}

/**
 * Se ejecuta cuando cambia cualquier contador de pasajeros
 */
// private onPassengerChange(): void {

//     this.totalPassengers = this.passengerCounts.reduce((sum, current) => sum + current, 0);

//     this.updateTotalPrice();
// }

onPassengerChange(): void {
  this.totalPassengers = this.passengerCounts.reduce((sum, count) => sum + count, 0);
  this.passengers = `${this.totalPassengers} pasajero${this.totalPassengers !== 1 ? 's' : ''}`;

  // Emitir datos actualizados si es necesario
  const passengerData = {
    adults: this.passengerCounts.find((count, index) =>
      this.optionsTour[0].paxPrices[index].paxType === 'ADULT'
    ) || 0,
    children: this.childAges // Array completo de edades de niños
  };

      this.updateTotalPrice();
}

/**
 * Actualiza el precio total basado en los contadores
 */
private updateTotalPrice(): void {
    let total = 0;

    this.optionsTour[0].paxPrices.forEach((price, index) => {
        const passengerCount = this.passengerCounts[index];
        total += price.amount * passengerCount;
    });

    // this.totalPrice = total;
}

    // let total = 0;
    // const paxPrices = this.optionsTour[0].paxPrices;

    // this.passengerCounts.forEach((count, index) => {
    //     if (count > 0 && paxPrices[index]) {
    //         total += count * paxPrices[index].amount;
    //     }
    // });

    // return total;

/**
 * Calcula el costo total para una opción específica del tour basándose en los contadores de pasajeros
 *
 * @param optionId - ID de la opción del tour para la cual se calcula el total
 * @returns Suma total del costo para todos los tipos de pasajero de la opción especificada
 *
 * @example
 * // Calcula el total para la opción con ID 5
 * const total = getSumPaxOption(5);
 * console.log(total); // 350.00
 */
getSumPaxOption(optionId?: number, option?: any): number {

  if(!optionId) {

      if(this.hourSelected) {
          const tour = this.getTourResultsAddItinerary(this.tour);

          if(!tour) {
            return 0;
          }

          optionId = tour.optionId;
      }

  }
    // Buscar la opción específica por ID
    const targetOption = this.tour.additionalInfo.tours.options.find(
        (option: any) => option.optionId === optionId
    );

    if (!targetOption) {
        return 0;
    }

    // let total = 0;

    // // Recorrer todos los tipos de pasajero y sus precios correspondientes
    // targetOption.paxPrices.forEach((paxPrice, index) => {
    //     const passengerCount = this.passengerCounts[index] || 0;
    //     const price = this.getPriceForPaxType(targetOption.prices, index);

    //     total += price * passengerCount;
    // });

    let total = 0;
    const paxPrices = this.optionsTour[0].profility;

    let passengerCountsArr: number[] = [];
    const categoryId: number = this.payload[0].categoriesId[0];

    switch(categoryId) {
      case 6:
           passengerCountsArr = this.passengerCounts || [];
        break;
      case 9:
           passengerCountsArr = option.passengerCounts || [];
        break;
    }

    if(passengerCountsArr && passengerCountsArr.length === 0) {
      return total;
    }

    passengerCountsArr.forEach((count, index) => {
        if (count > 0 && paxPrices[index]) {
            total += count * paxPrices[index].netPriceBooking;
        }
    });

    // return total;

    total = total + targetOption.netPriceBookingAddons;

    return total;
}

/**
 * Obtiene el precio correspondiente para un tipo específico de pasajero
 *
 * @param prices - Array de precios disponibles
 * @param paxIndex - Índice del tipo de pasajero en el array paxPrices
 * @returns Precio correspondiente al tipo de pasajero
 *
 * @private
 */
private getPriceForPaxType(prices: any[], paxIndex: number): number {

    // Si hay precios específicos para cada tipo de pasajero
    if (prices.length > paxIndex) {
        return prices[paxIndex]?.amountProf  || 0;
    }

    // Si hay menos precios que tipos de pasajero, usar el último precio disponible
    return prices[prices.length - 1]?.amountProf  || 0;
}

   // Aplica un filtro de css al elemento de imagen utilizando el color seteado por cliente.
   applyImageFilter() {
    const color = this.clientSetting?.clients_setting_global?.color_main_1;
    const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

    //Extraemos el literal en String de la conversión
    const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

    // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
    const colorRegex = /color\((.*)\)/;
    const colorMatch = tempFilterStr.match(colorRegex);
    const colorFilter = colorMatch ? colorMatch[1] : "";

    const filter = colorFilter;

    // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
    setTimeout(() => {
      this.icons.forEach(icon => {
        icon.nativeElement.setAttribute('style', `filter: ${filter}; width: 24px`);
      });
     // console.log(this.filter);
    }, 100);
  }

 getPaxPricesWithTotals(optionId?: number, option?: any): any[] {

    if(!optionId) {
      if(this.hourSelected) {
          const tour = this.getTourResultsAddItinerary(this.tour);

          if(!tour) {
            return [];
          }

          optionId = tour.optionId;
      }

    }

    const targetOption = this.tour.additionalInfo.tours.options.find(
        (option: any) => option.optionId === optionId
    );

    if (!targetOption) {
        return [];
    }

    let passengerCountsArr: number[] = [];
    const categoryId: number = this.payload[0].categoriesId[0];

    switch(categoryId) {
      case 6:
           passengerCountsArr = this.passengerCounts;
        break;
      case 9:
           passengerCountsArr = option.passengerCounts;
        break;
    }

    const pricesWithTotals = targetOption.paxPrices.map((paxPrice, index) => {
        const passengerCount = passengerCountsArr[index] || 0;
        const unitPrice = this.getPriceForPaxType(targetOption.prices, index);
        const total = unitPrice * passengerCount;
        const priceData = targetOption.prices[index] || targetOption.prices[targetOption.prices.length - 1];

        // Obtener los datos de profility y pricing para este paxType
        const profilityData = targetOption.profility?.find((p: any) => p.paxType === paxPrice.paxType && p.ageFrom === paxPrice.ageFrom && p.ageTo === paxPrice.ageTo) || {};
        const pricingData = targetOption.pricing?.find((p: any) => p.paxType === paxPrice.paxType && p.ageFrom === paxPrice.ageFrom && p.ageTo === paxPrice.ageTo) || {};

        // Calcular totales multiplicando por passengerCount
        return {
            // Datos de referencia de paxPrices
            paxType: paxPrice.paxType,
            ageFrom: paxPrice.ageFrom,
            ageTo: paxPrice.ageTo,

            // Datos reales de prices
            unitPrice: unitPrice,
            priceData: priceData,

            // Totales calculados
            total: total,
            passengerCount: passengerCount,

            // Referencia del precio original
            originalAmount: paxPrice.amount,

            // Datos de profility con totales
            profility: {
                blickoins: (profilityData.blickoins * passengerCount || 0) ,
                creditBlickoins: (profilityData.creditBlickoins  * passengerCount || 0),
                netPrice: (profilityData.netPrice || 0) * passengerCount,
                netPriceBooking: (profilityData.netPriceBooking * passengerCount || 0),
                netPriceCategory: (profilityData.netPriceCategory  * passengerCount || 0),
                netPriceProvider: (profilityData.netPriceProvider  * passengerCount || 0),
                paxType: profilityData.paxType,
                percentage: profilityData.percentage,
                percentageBooking: profilityData.percentageBooking,
                percentageCategory: profilityData.percentageCategory,
                percentageProvider: profilityData.percentageProvider
            },

            // Datos de pricing con totales
            pricing: {
                blickoins: (pricingData.blickoins * passengerCount || 0) ,
                blickoinsFactor: pricingData.blickoinsFactor,
                creditBlickoins: (pricingData.creditBlickoins * passengerCount || 0) ,
                creditFactor: pricingData.creditFactor,
                netPriceFreeTax: (pricingData.netPriceFreeTax * passengerCount || 0) ,
                netPriceProf: (pricingData.netPriceProf * passengerCount || 0),
                paxType: pricingData.paxType,
                percentage: pricingData.percentage,
                providerId: pricingData.providerId,
                totalPriceFreeTax: (pricingData.totalPriceFreeTax * passengerCount|| 0),
                totalPriceProf: (pricingData.totalPriceProf * passengerCount || 0)
            }
        };
    });

    return pricesWithTotals;
}

getDuration(duration: string): string {
  if (!duration) return 'Duración no disponible';

  try {
    const [time, type] = duration.split('-').map(part => part.trim());
    const timeNumber = parseInt(time, 10);

    if (isNaN(timeNumber)) return 'Duración inválida';

    // Mapeo de tipos a sus formas singular y plural
    const timeMap: { [key: string]: { singular: string, plural: string } } = {
      'DAYS': { singular: 'día', plural: 'días' },
      'HOURS': { singular: 'hora', plural: 'horas' },
      'MINUTES': { singular: 'minuto', plural: 'minutos' }
    };

    const timeType = type.toUpperCase();
    const timeConfig = timeMap[timeType];

    if (timeConfig) {
      const spanishType = timeNumber === 1 ? timeConfig.singular : timeConfig.plural;
      return `${timeNumber} ${spanishType}`;
    } else {
      // Para tipos no mapeados, usar el original
      return `${timeNumber} ${type.toLowerCase()}`;
    }

  } catch (error) {
    console.error('Error en getDuration:', error);
    return 'Error en duración';
  }
}

hourSelectedFX(time: string): void {
  if(!time) {
    return;
  }
  this.hourSelected = time;
}

selectLanguage(language: string): void {
  this.languageSelected = language;
}


getAvailabilityMessage(option): string {
  const paxesData = this.getPaxPricesWithTotals(option.optionId);
  const hasPassengers = paxesData ? paxesData.some(c => c.passengerCount > 0) : false;
  const hasDate = !!option.availableDates.find(c => c.from === this.dateSelect);

  if (!this.dateSelect) {
    return '';
  } else if (!hasDate) {
    return 'Esta opción no está disponible para la fecha seleccionada';
  } else if (!hasPassengers) {
    return 'Seleccionar al menos un pasajero';
  } else {
    return 'No disponible';
  }
}

isOptionAvailable(option): boolean {
  const paxesData = this.getPaxPricesWithTotals(option.optionId);
  const hasPassengers = paxesData ? paxesData.some(c => c.passengerCount > 0) : false;
  const hasDate = !!option.availableDates.find(c => c.from === this.dateSelect);

  return hasPassengers && hasDate;
}

schedulingArr(): any {
  if(this.tour.scheduling && !Array.isArray(this.tour.scheduling)) {
    this.tour.scheduling = [this.tour.scheduling];

}



}

getCancellationPrice(dataCancellation?: any, cancellationDate?: any): string | undefined {

    if (!dataCancellation) {
        if (this.hourSelected) {
            const tour = this.getTourResultsAddItinerary(this.tour);
            if (!tour) {
                return;
            }
            cancellationDate = tour.cancellation_policy;
            dataCancellation = tour.cancellationPolicies;
        }
    }

    if (dataCancellation && this._itemSelected && this._itemSelected?.availableDate && this._itemSelected?.availableDate?.arrivalDate) {

        // Normalizar la fecha de llegada a string YYYY-MM-DD
        let arrivalDateStr: string;
        if (this._itemSelected.availableDate.arrivalDate instanceof Date) {
            arrivalDateStr = this._itemSelected.availableDate.arrivalDate.toISOString().split('T')[0];
        } else {
            arrivalDateStr = this._itemSelected.availableDate.arrivalDate;
        }

        // Ahora comparar strings
        const found = dataCancellation.find((data: any) => data.from === arrivalDateStr);

        if (!found) {
            return 'Seleccionar fecha en calendario';
        }

        // Buscar en las cancellationPolicies del objeto FOUND, no de dataCancellation
        const policyAmountAvailable = found.cancellationPolicies.findIndex((c: any) => c.amount > 0);

        if (policyAmountAvailable !== -1) {
            // Devolver la fecha de la política encontrada en found.cancellationPolicies
            const dateFrom = found.cancellationPolicies[policyAmountAvailable].dateFrom;
            return dateFrom;
        }

        return 'Seleccionar fecha en calendario';
    }
}


isDate(value: any): boolean {
    if (!value) return false;

    // Si es el string específico que causa problemas
    if (value === 'Seleccionar fecha en calendario') {
        return false;
    }

    // Verificar si es una fecha válida
    const date = new Date(value);
    return !isNaN(date.getTime());
}

hourDaySelected(): string[] {
  if (!this._itemSelected?.availableDate?.arrivalDate || !this.tour?.additionalInfo?.tours?.options) {
    return [];
  }

  const allHours: string[] = [];

  // Recorrer todas las opciones
  this.tour.additionalInfo.tours.options.forEach((option: any) => {
    // Verificar si la opción tiene availableDates
    if (option.availableDates && Array.isArray(option.availableDates)) {
      // Recorrer todas las fechas disponibles de cada opción
      option.availableDates.forEach((dateInfo: any) => {
        // Verificar si tiene hoursAvail y es un array
        if (dateInfo.hoursAvail && Array.isArray(dateInfo.hoursAvail)) {
          // Agregar todos los horarios
          allHours.push(...dateInfo.hoursAvail);
        }
      });
    }
  });

  // Eliminar duplicados y ordenar
  const uniqueHours = [...new Set(allHours)].sort();
  return uniqueHours;
}

selectHourTicket(hour: any): void {

  if(this.ticketsSelected && this.ticketsSelected.length > 0) {
    this.ticketsSelected = [];

       setTimeout(() => {
          this.mySelect.value = this.ticketsSelected;
        });
  }

  this.hourSelected = hour;
}

getAmenitieTrasnsfer(amenities: any[], type: string): boolean | any {
  if(!Array.isArray(amenities) || amenities.length === 0) {
    return false;
  }

  let exists: boolean = false;
  let transfer: any;

  amenities.forEach((amenity: any) => {
    if(amenity.description) {
      if(type === 'valid') {
        exists = amenity.description && amenity.totalPriceProf > 0 ? true : false;
      }
      if(type === 'transfer' && amenity.description === 'Cargo de Traslado') {
        transfer = amenity;
      }
    }

  });

  if(type === 'valid') {
    return exists;
  }
  if(type === 'transfer') {
    return transfer;
  }
}

isTransferSelected(event: any, checked: boolean, option: any, amenity?: any, amenityPrice?: any): void {

  this.toggleAddons(event, option, amenity, amenityPrice);

  if(checked) {
    this.isTransferSelect = true;
  } else {
    this.isTransferSelect = false;
  }

}

addonsIsSelected(option: any, amenity: any): boolean {

       if(this.payload[0].categoriesId[0] === 6) {

       if(this.getLanguageGuide(option).length > 1 && !this.languageSelected) {
        return false;
      }

      if(this.getHoursAvailTickets(option).length > 1 && !this.hourSelected) {
        return false;
      }

    }


  if (!option?.addonsIncluded || !Array.isArray(option.addonsIncluded) || option.addonsIncluded.length === 0) {
    return false;
  }

  const isSelected = option.addonsIncluded.some((addon: any) =>
    addon?.id === amenity.id
  );

  return isSelected;
}

toggleAddons(event: any, option: any, extra: any, extraPrice: number): void {
     if(this.payload[0].categoriesId[0] === 6) {

       if(this.getLanguageGuide(option).length > 1 && !this.languageSelected) {
        event.preventDefault(); // Prevenir el cambio
        event.stopPropagation(); // Detener propagación
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione un idioma');
        return
      }

      if(this.getHoursAvailTickets(option).length > 1 && !this.hourSelected) {
        event.preventDefault(); // Prevenir el cambio
        event.stopPropagation(); // Detener propagación
        this.continueValidProcess = true;
        this.notificationService.warning('Seleccione un horario');
        return
      }


      let tourOption: any;

      if(this.getLanguageGuide(option).length > 0 && this.getHoursAvailTickets(option).length > 0) {
        tourOption = this.tour.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected &&
                                                                    c.language === this.languageSelected);
      }

       if(this.getLanguageGuide(option).length > 0 && this.getHoursAvailTickets(option).length === 0) {
        tourOption = this.tour.additionalInfo?.tours?.options?.find(c => c.sessions === this.hourSelected);
      }

      if(this.getLanguageGuide(option).length === 0 && this.getHoursAvailTickets(option).length > 0) {
        tourOption = this.tour



    }

          if(tourOption) {
        option = tourOption;
      }

  }

  const index = option.addonsIncluded.findIndex(a => a.id === extra.id);

  if (index >= 0) {
    // Deseleccionar solo este addon específico
    option.addonsIncluded.splice(index, 1);
    option.netPriceBookingAddons -= extraPrice;
  } else {
    // Agregar nuevo addon sin remover los anteriores
    option.addonsIncluded.push(extra);
    option.netPriceBookingAddons += extraPrice;
  }
}

onSelectOpened() {
  setTimeout(() => {
    this.updateCheckboxColor();
    this.setupCheckboxObserver();
  }, 0);
}

private updateCheckboxColor() {
  const dynamicColor = this.clientSetting?.clients_setting_global?.color_main_1 || '#000000';

  // Buscar todos los checkboxes en el panel
  const checkboxes = document.querySelectorAll('.mat-select-panel .mat-pseudo-checkbox');

  checkboxes.forEach((checkbox: Element) => {
    const htmlCheckbox = checkbox as HTMLElement;

    // Aplicar color de fondo y borde basado en el estado
    if (checkbox.classList.contains('mat-pseudo-checkbox-checked') ||
        checkbox.classList.contains('mat-pseudo-checkbox-indeterminate')) {
      // Si está checked - aplicar color dinámico
      this.renderer.setStyle(htmlCheckbox, 'background', dynamicColor);
      this.renderer.setStyle(htmlCheckbox, 'border-color', dynamicColor);
    } else {
      // Si no está checked - resetear a color por defecto
      this.renderer.setStyle(htmlCheckbox, 'background', '');
      this.renderer.setStyle(htmlCheckbox, 'border-color', '');
    }
  });
}

private setupCheckboxObserver() {
  const panel = document.querySelector('.mat-select-panel');
  if (!panel) return;

  // Configurar observer para detectar cambios en las clases
  this.observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        shouldUpdate = true;
      }
    });

    if (shouldUpdate) {
      this.updateCheckboxColor();
    }
  });

  // Observar cambios en todos los checkboxes del panel
  const checkboxes = panel.querySelectorAll('.mat-pseudo-checkbox');
  checkboxes.forEach(checkbox => {
    this.observer.observe(checkbox, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

onSelectClosed() {
  if (this.observer) {
    this.observer.disconnect();
  }
}

  // /**
  //  * Alterna visibilidad del tooltip de eliminación
  //  */
  // toggleDeleteTooltip(index): void {

  //   if(this.showDeleteTooltip[index]) {
  //     this.showDeleteTooltip[index] = false;
  //   } else {
  //   this.showDeleteTooltip[index] = true;
  //   }

  // }

  // removerPax(index: number): void {

  // }

  // selectedPax(ticketIndex: number, paxIndex: number): void {
  //   if (paxIndex >= 0 && paxIndex < this.availablePassengers.length) {
  //     const selectedPax = {...this.availablePassengers[paxIndex]};

  //     if(this.ticketsSelected[ticketIndex].paxType) {
  //       this.availablePassengers.push(this.ticketsSelected[ticketIndex].paxType);
  //     }

  //     // Asignar el pasajero al ticket
  //     this.ticketsSelected[ticketIndex].paxType = selectedPax;
  //     this.ticketsSelected[ticketIndex].selectedOptionPaxType = true;

  //     this.availablePassengers.splice(paxIndex, 1);
  //     // Cerrar el tooltip
  //     this.closeTooltip(ticketIndex);

  //     // Actualizar la UI
  //     this.cdr.detectChanges();

  //   }
  // }

  // closeTooltip(index: number): void {
  //     this.showDeleteTooltip[index] = false;
  // }

  getPriceSelectedTicket(ticket: any): number {

    const indexPaxSelect = ticket.paxPrices.findIndex(c => c.paxType === ticket.paxType.type);

    if(indexPaxSelect !== -1) {

      let price = ticket.prices[indexPaxSelect].amountProf;

      price = this.currencyPipe.transform(
                                          price,
                                          this.tour.additionalInfo.currency,
                                          this.currencyAgency?.code,
                                          this.currencies);

      return price;

    }

    return 0;
  }

  // getPlaceHolderTickets(): string {

  //   if(!this._itemSelected?.availableDate?.arrivalDate) {
  //     return 'Selecciona una fecha del calendario';
  //   }

  //   if(!this.hourSelected) {
  //      return 'Selecciona un horario';
  //   }

  //   if(this._itemSelected?.availableDate?.arrivalDate && this.hourSelected) {
  //     return 'Seleccione una opción';
  //   }


  // }

  // removeSelectedPaxTypeTicket(selectedPaxType: any, selectedTicket: any): void {
  //   if(selectedPaxType) {
  //     this.availablePassengers.push(selectedPaxType);

  //     delete selectedTicket.paxType;
  //     delete selectedTicket.selectedOptionPaxType;

  //   }
  // }


  validPaymentConditionAgencyAvailable(rateClass: any): boolean {

    if(!rateClass) {

      if(!this.hourSelected) {
          return true;
        }

      rateClass = this.getTourResultsAddItinerary(this.tour);
      if(!rateClass) {
        return true;
      }
    }

    const result = rateClass === 'NR'
      ? this.paymentAgencyActive.non_refundable === 0 ? false : true
      : true;

    return result;
  }

getOptionsTickets(options: any[]): any[] {

  const optionTickets = this.tour.additionalInfo.tours.options;

  if (!optionTickets || !Array.isArray(optionTickets)) {
    return [];
  }

  const selectedHour = this.hourSelected;

  // Si hay una hora específica seleccionada
  if (selectedHour) {
    return this.getOptionsForSpecificHour(optionTickets, selectedHour);
  }

  // Si no hay hora seleccionada, devolver una opción por cada horario único
  return this.getOneOptionPerUniqueHour(optionTickets);
}

/**
 * Devuelve opciones que tienen una hora específica (puede haber varias)
 * y luego selecciona solo una para esa hora
 */
private getOptionsForSpecificHour(options: any[], targetHour: string): any[] {
  // Filtrar opciones que tengan la hora seleccionada
  const optionsWithTargetHour = options.filter(option => {
    return this.doesOptionHaveHour(option, targetHour);
  });

  // Si hay opciones con esa hora, devolver solo una
  // if (optionsWithTargetHour.length > 0) {
  //   // Seleccionar la "mejor" opción (ej: primera, más barata, etc.)
  //   console.log([this.selectBestOption(optionsWithTargetHour)])
  //   return [this.selectBestOption(optionsWithTargetHour)];
  // }
  // console.log(optionsWithTargetHour)
  return optionsWithTargetHour;

  return [];
}

/**
 * Verifica si una opción tiene una hora específica
 */
private doesOptionHaveHour(option: any, targetHour: string): boolean {
  if (!option.availableDates || !Array.isArray(option.availableDates)) {
    return false;
  }

  // Buscar en todas las fechas si alguna tiene la hora
  return option.availableDates.some(dateInfo => {
    return dateInfo.hoursAvail &&
           Array.isArray(dateInfo.hoursAvail) &&
           dateInfo.hoursAvail.includes(targetHour);
  });
}

/**
 * Devuelve una opción por cada horario único
 */
private getOneOptionPerUniqueHour(options: any[]): any[] {
  const hourToOptionMap = new Map<string, any>();

  // Recorrer todas las opciones
  options.forEach(option => {
    // Obtener todas las horas únicas de esta opción
    const uniqueHours = this.getUniqueHoursFromOption(option);

    // Para cada hora, si no existe en el mapa, agregar esta opción
    uniqueHours.forEach(hour => {
      if (!hourToOptionMap.has(hour)) {
        hourToOptionMap.set(hour, option);
      }
    });
  });

  // Convertir a array, ordenar por hora y devolver solo las opciones
  return Array.from(hourToOptionMap.entries())
    .sort(([hourA], [hourB]) => this.compareHours(hourA, hourB))
    .map(([_, option]) => option);
}

/**
 * Compara dos horas para ordenamiento correcto (no alfabético)
 */
private compareHours(hourA: string, hourB: string): number {
  const timeToMinutes = (timeStr: string) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + (minutes || 0);
  };

  return timeToMinutes(hourA) - timeToMinutes(hourB);
}

/**
 * Obtiene horas únicas de una opción
 */
private getUniqueHoursFromOption(option: any): string[] {
  const hoursSet = new Set<string>();

  if (option.availableDates && Array.isArray(option.availableDates)) {
    option.availableDates.forEach(dateInfo => {
      if (dateInfo.hoursAvail && Array.isArray(dateInfo.hoursAvail)) {
        dateInfo.hoursAvail.forEach(hour => {
          if (hour && typeof hour === 'string') {
            hoursSet.add(hour);
          }
        });
      }
    });
  }

  return Array.from(hoursSet);
}

/**
 * Selecciona la "mejor" opción de un array
 */
private selectBestOption(options: any[]): any {
  if (options.length === 0) return null;
  if (options.length === 1) return options[0];

  // Criterio: seleccionar por menor precio
  return options.reduce((best, current) => {
    const bestPrice = this.getOptionPrice(best);
    const currentPrice = this.getOptionPrice(current);

    return currentPrice < bestPrice ? current : best;
  });
}

/**
 * Obtiene el precio de una opción
 */
private getOptionPrice(option: any): number {
  return option.totalPrice ||
         option.prices?.[0]?.amount ||
         option.pricing?.[0]?.price ||
         0;
}


getNameTourHourHidden(): string {
 const option = this.getTourResultsAddItinerary(this.tour);

 if(option) {

  if(this.tour.scheduling && Array.isArray(this.tour.scheduling) && this.tour.scheduling.length > 0) {
    return this.tour.title;
  } else {
    return option.option_name || this.tour.company;
  }

 } else {
  return 'Seleccione las opciones';
 }
}

          getIconsComments(index: number): string {

            switch(index) {
              case 0:
                return '../../../../assets/icons/comments-assesment/MALO.svg';
              case 1:
                return '../../../../assets/icons/comments-assesment/REGULAR.svg';
              case 2:
                return '../../../../assets/icons/comments-assesment/BUENO.svg';
              case 3:
                return '../../../../assets/icons/comments-assesment/MUYBUENO.svg';
              case 4:
                return '../../../../assets/icons/comments-assesment/EXCELENTE.svg';
            }

          }

          getImagesTourWithsHours(): any[] {

            const priceTotal = this.getPaxPricesWithTotals().length > 0;

            if(priceTotal) {

              const option = this.getTourResultsAddItinerary(this.tour);

              if(option && option.images && option.images.length > 0) {
                return option.images
              } else {
                return this.tour.additionalInfo?.images;
              }
            }

            return this.tour.additionalInfo?.images;
          }

          getQuestionsName(code: string): string {

            if(code === 'HOTEL' || code === 'HOTEL_NAME') {
              return 'Hotel';
            }
            if(code === 'PHONENUMBER') {
              return 'Teléfono';
            }
            if(code === 'EMAIL') {
              return 'Email';
            }

          }

            getCommentadjective(average: any): any {
              return getCommentadjective(average);
            }

                        getPaxTypeMessage(type: string): string {

              let paxType: string = type

              switch(type) {
                case 'ADULT': paxType = 'adulto'; break;
                case 'CHILD': paxType = 'niño'; break;
                case 'INFANT': paxType = 'infante'; break;
              }


              return paxType;
            }

            getPaxType(type: string): string {

              let paxType: string = type

              switch(type) {
                case 'ADULT': paxType = 'Adultos'; break;
                case 'CHILD': paxType = 'Niños'; break;
                case 'INFANT': paxType = 'Bebe'; break;
              }


              return paxType;
            }

            verifyChildren(): boolean {
              const paxPrices = this.optionsTour[0].paxPrices;
              if(paxPrices.find(p => p.paxType === 'CHILD' || p.paxType === 'INFANT')) {
                return false
              }
              return true;
            }


            getPrice(paxType: any): string {

              const pax: any = this.optionsTour[0].profility.find((p: any) => p.paxType === paxType);

              return `${this.currencyAgency?.code} ${pax.netPriceBooking}`;
            }


            goPhotosFx(): void {
              this.tab = 'photos';
            }

            routesOptionOpen(): void {
              this.routesOption = !this.routesOption;
            }

            /**
             * Alterna la visibilidad del cronograma de una ruta dentro de una opción.
             */
            toggleRoute(option: any, optionIndex: number, routes: any, routeIndex: number): void {
              const key = this._getCronogramaKey(option, optionIndex);
              const state = this._cronogramaStateByOption.get(key) ?? {
                stopsRoute: [],
                selectedRouteIndex: -1,
                routeVisible: false
              };

              if (state.selectedRouteIndex === routeIndex) {
                // Cerrar
                this._cronogramaStateByOption.set(key, {
                  stopsRoute: [],
                  selectedRouteIndex: -1,
                  routeVisible: false
                });
              } else {
                // Abrir
                const route = routes[routeIndex];
                const newStops = route.points || [];
                this._cronogramaStateByOption.set(key, {
                  stopsRoute: newStops,
                  selectedRouteIndex: routeIndex,
                  routeVisible: true
                });
                if (newStops.length > 0) {
                  this.getStopCircleStyles(newStops[0]);
                  this.selectStop(newStops[0], option, optionIndex);
                }
              }
            }

            /**
             * Helpers para que la plantilla lea estado per-opción.
             */
            getStopsRouteForOption(option: any, optionIndex: number): any[] {
              const key = this._getCronogramaKey(option, optionIndex);
              return this._cronogramaStateByOption.get(key)?.stopsRoute ?? [];
            }

            getSelectedRouteIndexForOption(option: any, optionIndex: number): number {
              const key = this._getCronogramaKey(option, optionIndex);
              return this._cronogramaStateByOption.get(key)?.selectedRouteIndex ?? -1;
            }

            isRouteVisibleForOption(option: any, optionIndex: number): boolean {
              const key = this._getCronogramaKey(option, optionIndex);
              return this._cronogramaStateByOption.get(key)?.routeVisible ?? false;
            }

          getStopCircleStyles(stop: any): any {
            const mainColor = this.clientSetting?.clients_setting_global?.color_main_1;
            const isActive = this.selectedStop?.order === stop.order;

            return {
              'border': isActive ? `2px solid ${mainColor}` : '2px solid #ececec',
              'background-color': 'transparent',
              'cursor': 'pointer',
              'transition': 'all 0.3s ease'
            };
          }

// ==================== MÉTODOS PRINCIPALES ====================

/**
 * Maneja la selección/deselección de tickets
 */
toggleTap(event: any): void {
  const newValue = event.value;
  const previousValue = this.ticketsSelected;
  const totalPassengers = this.totalPassengers;
  const availableOptions = this.getOptionsTickets(this.optionsTour);

  // ESCENARIO: Una sola opción disponible
  if (availableOptions.length === 1 && newValue.length === 1 && previousValue.length === 0) {
    const selectedOption = this.cleanTicketObject(newValue[0]);
    selectedOption.isForAllPassengers = true;
    selectedOption.assignedPaxType = null;
    selectedOption.quantity = totalPassengers;
    this.ticketsSelected = [selectedOption];
    this.notificationService.info(`La opción "${selectedOption.option_name}" se aplicará a todos los ${totalPassengers} pasajeros`);
    return;
  }

  // ESCENARIO: Múltiples opciones - verificar límite máximo
  if (newValue.length > totalPassengers) {
    this.notificationService.info(`Solo puedes seleccionar hasta ${totalPassengers} tickets para ${totalPassengers} pasajeros`);
    setTimeout(() => {
      this.mySelect.value = previousValue;
      this.ticketsSelected = [...previousValue];
    });
    return;
  }

  // ✅ MANTENER tickets existentes, solo limpiar los NUEVOS
  const existingTicketsMap = new Map();
  previousValue.forEach((ticket: any) => {
    existingTicketsMap.set(ticket.optionId, ticket);
  });

  const newTicketsList: any[] = [];
  newValue.forEach((ticket: any) => {
    if (existingTicketsMap.has(ticket.optionId)) {
      // Ticket ya existía → mantenerlo con sus datos (asignaciones incluidas)
      newTicketsList.push(existingTicketsMap.get(ticket.optionId));
    } else {
      // Ticket nuevo → limpiarlo
      newTicketsList.push(this.cleanTicketObject(ticket));
    }
  });

  this.ticketsSelected = newTicketsList;

  // Detectar si se agregó un ticket nuevo
  if (newTicketsList.length > previousValue.length) {
    const addedTicket = newTicketsList[newTicketsList.length - 1];
    if (addedTicket && !addedTicket.isForAllPassengers) {
      const newTicketIndex = newTicketsList.length - 1;
      setTimeout(() => {
        this.toggleDeleteTooltip(newTicketIndex);
      }, 100);
    }
  }

  // Actualizar availablePassengers
  this.updateAvailablePassengers();
  this.applyImageFilter();
}

/**
 * Limpia un objeto ticket (SOLO PARA TICKETS NUEVOS)
 */
private cleanTicketObject(ticket: any): any {
    // Crear una copia limpia del ticket
    const cleanTicket = { ...ticket };

    // Eliminar propiedades que no deberían persistir
    delete cleanTicket.assignedPassengers;
    delete cleanTicket.passengerCounts;
    delete cleanTicket.assignedPaxType;
    delete cleanTicket.selectedOptionPaxType;
    delete cleanTicket.quantity;
    delete cleanTicket.isForAllPassengers;
    delete cleanTicket.totalPrice;
    delete cleanTicket.paxesData;

    // Inicializar propiedades nuevas
    cleanTicket.assignedPassengers = [];
    cleanTicket.passengerCounts = Array(ticket.paxPrices?.length || 0).fill(0);
    cleanTicket.assignedPaxType = null;
    cleanTicket.selectedOptionPaxType = false;
    cleanTicket.quantity = 0;
    cleanTicket.isForAllPassengers = false;
    cleanTicket.totalPrice = 0;

    return cleanTicket;
}
/**
 * Elimina un ticket de la selección
 */
removeTicketSelected(index: number): void {
  const removedTicket = this.ticketsSelected[index];

  // Si el ticket tenía un pasajero asignado, devolverlo a availablePassengers
  if (removedTicket.assignedPaxType && removedTicket.paxType) {
    this.availablePassengers.push(removedTicket.paxType);
  }

  this.ticketsSelected = this.ticketsSelected.filter((_, i) => i !== index);
  this.showDeleteTooltip[index] = false;

  if (this.mySelect) {
    this.mySelect.value = this.ticketsSelected;
  }

  this.updateAvailablePassengers();
}

onPassengerSelectionChange(event: any, ticketIndex: number): void {

    const selectedIndices = event.value || [];
    const ticket = this.ticketsSelected[ticketIndex];

    // Inicializar array de pasajeros asignados si no existe
    if (!ticket.assignedPassengers) {
        ticket.assignedPassengers = [];
        ticket.passengerCounts = Array(ticket.paxPrices.length).fill(0);
    }

    // Resetear passengerCounts y assignedPassengers
    const newAssignedPassengers: any[] = [];
    const newPassengerCounts = Array(ticket.paxPrices.length).fill(0);

    // Recorrer los índices seleccionados
    selectedIndices.forEach((paxIndex: number) => {
        if (paxIndex >= 0 && paxIndex < this.availablePassengers.length) {
            const selectedPax = { ...this.availablePassengers[paxIndex] };
            newAssignedPassengers.push(selectedPax);

            // Actualizar contador por tipo
            const paxTypeIndex = ticket.paxPrices.findIndex((c: any) => c.paxType === selectedPax.type);
            if (paxTypeIndex !== -1) {
                newPassengerCounts[paxTypeIndex] = (newPassengerCounts[paxTypeIndex] || 0) + 1;
            }
        }
    });

    // Actualizar el ticket
    ticket.assignedPassengers = newAssignedPassengers;
    ticket.passengerCounts = newPassengerCounts;
    ticket.quantity = newAssignedPassengers.length;
    ticket.selectedOptionPaxType = newAssignedPassengers.length > 0;
    ticket.isForAllPassengers = false;
    ticket.assignedPaxType = null;
    ticket.paxesData = this.getPaxPricesWithTotals(ticket.optionId, ticket);

    // Recalcular precio total
    ticket.totalPrice = this.calculateTicketTotalPrice(ticket);

    this.cdr.detectChanges();
}
/**
 * Agrega un pasajero a un ticket
 */
private addPassengerToTicket(ticket: any, passenger: any): void {

    // Verificar si ya existe (por ID único)
    const exists = ticket.assignedPassengers.some((p: any) => p.id === passenger.id);
    if (exists) {
        return;
    }

    // Agregar el nuevo pasajero
    ticket.assignedPassengers.push(passenger);

    // Actualizar contadores por tipo
    const paxTypeIndex = ticket.paxPrices.findIndex((c: any) => c.paxType === passenger.type);

    if (paxTypeIndex !== -1) {
        ticket.passengerCounts[paxTypeIndex] = (ticket.passengerCounts[paxTypeIndex] || 0) + 1;
    }

    ticket.assignedPaxType = null;
    ticket.selectedOptionPaxType = true;
    ticket.quantity = ticket.assignedPassengers.length;
    ticket.isForAllPassengers = false;
}


/**
 * Elimina un pasajero específico de un ticket
 */
removePaxFromTicket(ticketIndex: number, paxIndexInTicket: number, pax: any): void {
    const ticket = this.ticketsSelected[ticketIndex];

    if (!ticket.assignedPassengers || ticket.assignedPassengers.length === 0) {
        return;
    }

    // 1. Remover el pasajero del ticket
    ticket.assignedPassengers.splice(paxIndexInTicket, 1);
    ticket.quantity = ticket.assignedPassengers.length;

    // 2. Actualizar passengerCounts
    const paxTypeIndex = ticket.paxPrices.findIndex((c: any) => c.paxType === pax.type);
    if (paxTypeIndex !== -1) {
        ticket.passengerCounts[paxTypeIndex] = Math.max(0, (ticket.passengerCounts[paxTypeIndex] || 0) - 1);
    }

    // 3. Recalcular precio total
    ticket.totalPrice = this.calculateTicketTotalPrice(ticket);

    // 4. Devolver el pasajero a availablePassengers
    const existingPax = this.availablePassengers.find(ap => ap.id === pax.id);
    if (!existingPax) {
        this.availablePassengers.push(pax);
        this.sortAvailablePassengers();
    }

    // 5. Si no quedan pasajeros, limpiar el ticket
    if (ticket.assignedPassengers.length === 0) {
        ticket.selectedOptionPaxType = false;
        ticket.totalPrice = 0;
    }

    // 6. ✅ FORZAR ACTUALIZACIÓN DEL MAT-SELECT
    // Crear una copia del array para forzar la detección de cambios
    this.availablePassengers = [...this.availablePassengers];

    // 7. Forzar actualización de la vista
    this.cdr.detectChanges();
}

/**
 * Obtiene los índices de los pasajeros asignados a un ticket
 * para sincronizar el mat-select
 */
getSelectedPassengerIndices(ticketIndex: number): number[] {
    const ticket = this.ticketsSelected[ticketIndex];
    if (!ticket.assignedPassengers || ticket.assignedPassengers.length === 0) {
        return [];
    }

    // Obtener los índices de los pasajeros en availablePassengers
    const indices: number[] = [];
    ticket.assignedPassengers.forEach((assignedPax: any) => {
        const idx = this.availablePassengers.findIndex(ap => ap.id === assignedPax.id);
        if (idx !== -1) {
            indices.push(idx);
        }
    });

    return indices;
}

/**
 * Ordena availablePassengers por tipo (adultos primero, luego niños, etc.)
 */
private sortAvailablePassengers(): void {
    const order: { [key: string]: number } = {
        'ADULT': 1,
        'CHILD': 2,
        'INFANT': 3,
        'SENIOR': 4
    };

    this.availablePassengers.sort((a, b) => {
        return (order[a.type] || 99) - (order[b.type] || 99);
    });
}

/**
 * Verifica si un pasajero ya está asignado a otro ticket
 */
isPassengerAlreadyAssignedToOtherTicket(passenger: any, currentTicketIndex: number): boolean {

    for (let i = 0; i < this.ticketsSelected.length; i++) {
        if (i === currentTicketIndex) {
            continue;
        }

        const ticket = this.ticketsSelected[i];
        const assignedIds = ticket.assignedPassengers?.map((p: any) => p.id) || [];

        if (ticket.assignedPassengers && ticket.assignedPassengers.length > 0) {
            const exists = ticket.assignedPassengers.some((p: any) => p.id === passenger.id);
            if (exists) {
                return true;
            }
        }
    }
    return false;
}

/**
 * Calcula el precio total de un ticket basado en sus passengerCounts
 */
calculateTicketTotalPrice(ticket: any): number {
  if (!ticket || !ticket.paxPrices || !ticket.passengerCounts) {
    return 0;
  }

  let total = 0;

  for (let i = 0; i < ticket.paxPrices.length; i++) {
    const paxPrice = ticket.paxPrices[i];
    const count = ticket.passengerCounts[i] || 0;

    if (count > 0 && paxPrice) {
      // Obtener el precio unitario para este tipo de pasajero
      let unitPrice = 0;

      // Buscar el precio en prices o profility
      if (ticket.prices && ticket.prices[i]) {
        unitPrice = ticket.prices[i].amountProf || ticket.prices[i].amount || 0;
      } else if (ticket.profility && ticket.profility[i]) {
        unitPrice = ticket.profility[i].netPriceBooking || 0;
      } else {
        unitPrice = paxPrice.amount || 0;
      }

      total += unitPrice * count;
    }
  }

  return total;
}

/**
 * Obtiene el precio total de todos los tickets
 */
getSumPaxOptionTotalTickets(): number {
  if (!this.ticketsSelected || this.ticketsSelected.length === 0) {
    return 0;
  }

  let total = 0;

  for (const ticket of this.ticketsSelected) {
    if (ticket.isForAllPassengers) {
      total += this.getTicketPriceForAllPassengers(ticket);
    } else if (ticket.assignedPassengers && ticket.assignedPassengers.length > 0) {
      total += ticket.totalPrice || this.calculateTicketTotalPrice(ticket);
    }
  }

  return total;
}
/**
 * Obtiene el resumen de pasajeros asignados a un ticket
 */
getTicketAssignedSummary(ticket: any): string {
  if (!ticket.assignedPassengers || ticket.assignedPassengers.length === 0) {
    return 'Sin asignar';
  }

  const counts: { [key: string]: number } = {};
  ticket.assignedPassengers.forEach((pax: any) => {
    counts[pax.type] = (counts[pax.type] || 0) + 1;
  });

  const parts: string[] = [];
  Object.entries(counts).forEach(([type, count]) => {
    parts.push(`${count} ${this.getPaxTypeLabel(type)}${count > 1 ? 'es' : ''}`);
  });

  return parts.join(', ');
}


/**
 * Remueve un pasajero de un ticket
 */
private removePassengerFromTicket(ticket: any, passenger: any): void {
    const passengerIndex = ticket.assignedPassengers.findIndex((p: any) => p.id === passenger.id);
    if (passengerIndex === -1) return;

    // Remover el pasajero
    ticket.assignedPassengers.splice(passengerIndex, 1);
    ticket.quantity = ticket.assignedPassengers.length;

    // Actualizar contadores por tipo
    const paxTypeIndex = ticket.paxPrices.findIndex((c: any) => c.paxType === passenger.type);
    if (paxTypeIndex !== -1) {
        ticket.passengerCounts[paxTypeIndex] = Math.max(0, (ticket.passengerCounts[paxTypeIndex] || 0) - 1);
    }

    // Devolver el pasajero a availablePassengers
    this.availablePassengers.push(passenger);

    // Si no quedan pasajeros, limpiar el ticket
    if (ticket.assignedPassengers.length === 0) {
        ticket.assignedPaxType = null;
        ticket.selectedOptionPaxType = false;
        ticket.quantity = 0;
        ticket.totalPrice = 0;
    }
}

/**
 * Obtiene el precio total de un ticket basado en sus pasajeros asignados
 */
getTicketTotalPrice(ticket: any): number {
  if (!ticket.assignedPassengers || ticket.assignedPassengers.length === 0) {
    return 0;
  }

  if (ticket.isForAllPassengers) {
    return this.getTicketPriceForAllPassengers(ticket);
  }

  let total = 0;
  ticket.assignedPassengers.forEach((pax: any) => {
    const price = this.getPriceForPaxType(ticket, pax.type);
    total += price;
  });

  return total;
}

/**
 * Obtiene el precio total de todos los tickets
 */
// getSumPaxOptionTotalTickets(): number {
//   if (!this.ticketsSelected || this.ticketsSelected.length === 0) {
//     return 0;
//   }

//   let total = 0;

//   for (const ticket of this.ticketsSelected) {
//     if (ticket.isForAllPassengers) {
//       total += this.getTicketPriceForAllPassengers(ticket);
//     } else if (ticket.assignedPassengers && ticket.assignedPassengers.length > 0) {
//       total += this.getTicketTotalPrice(ticket);
//     }
//   }

//   return total;
// }


/**
 * Genera un ID único para un pasajero
 */
private generatePassengerId(paxType: string, age: number | null): string {
    // Incrementar el contador para este tipo
    this.passengerCounts[paxType] = (this.passengerCounts[paxType] || 0) + 1;
    const counter = this.passengerCounts[paxType];
    return `${paxType}_${counter}_${Date.now()}_${Math.random()}`;
}

/**
 * Actualiza la lista de pasajeros disponibles para asignar
 * Mantiene los IDs existentes, solo ajusta cantidades
 */
updateAvailablePassengers(): void {
  if (this.ticketsSelected.length === 1 && this.ticketsSelected[0]?.isForAllPassengers) {
    this.availablePassengers = [];
    return;
  }

  // ✅ Mantener los pasajeros que YA EXISTEN en availablePassengers
  // Solo eliminar los que ya no deberían estar (por decremento)

  const paxPrices = this.optionsTour[0]?.paxPrices || [];

  // Calcular cuántos de cada tipo deberían haber
  const expectedCounts: { [key: string]: number } = {};
  for (let i = 0; i < paxPrices.length; i++) {
    const paxType = paxPrices[i].paxType;
    expectedCounts[paxType] = this.passengerCounts[i] || 0;
  }

  // Contar cuántos de cada tipo hay actualmente en availablePassengers
  const currentCounts: { [key: string]: number } = {};
  this.availablePassengers.forEach(p => {
    currentCounts[p.type] = (currentCounts[p.type] || 0) + 1;
  });

  // Si las cantidades coinciden, no hacer nada
  if (JSON.stringify(expectedCounts) === JSON.stringify(currentCounts)) {
    return;
  }

  // Si no coinciden, reconstruir desde cero preservando los asignados
  this.rebuildAvailablePassengers();
}

/**
 * Reconstruye availablePassengers preservando IDs de pasajeros asignados
 */
private rebuildAvailablePassengers(): void {
  const paxPrices = this.optionsTour[0]?.paxPrices || [];

  // Obtener los pasajeros que están asignados a tickets (preservar sus IDs)
  const assignedPassengersMap = new Map<string, any>();
  this.ticketsSelected.forEach(ticket => {
    ticket.assignedPassengers?.forEach((p: any) => {
      assignedPassengersMap.set(p.id, p);
    });
  });

  const newAvailable: any[] = [];

  for (let i = 0; i < paxPrices.length; i++) {
    const price = paxPrices[i];
    const paxType = price.paxType;
    const totalNeeded = this.passengerCounts[i] || 0;

    // Separar los que ya están asignados de este tipo
    const assignedOfType = Array.from(assignedPassengersMap.values())
      .filter(p => p.type === paxType);

    // Agregar los asignados primero (con sus IDs originales)
    newAvailable.push(...assignedOfType);

    // ✅ Para los que faltan, usar las edades REALES de agesByPaxType
    const missingCount = totalNeeded - assignedOfType.length;

    if (missingCount > 0) {
      if (this.paxTypeRequiresAge(paxType)) {
        // ✅ Obtener las edades REALES de este tipo (las de búsqueda)
        const realAges = this.agesByPaxType[paxType] || [];

        // Filtrar las edades que ya están asignadas
        const assignedAges = new Set(assignedOfType.map(p => p.age));
        const availableRealAges = realAges.filter(age => !assignedAges.has(age));


        // Usar las edades reales para los que faltan
        for (let j = 0; j < missingCount && j < availableRealAges.length; j++) {
          const realAge = availableRealAges[j];
          const newId = `${paxType}_${realAge}_${Date.now()}_${Math.random()}`;

          newAvailable.push({
            type: paxType,
            ageRange: { from: price.ageFrom, to: price.ageTo },
            age: realAge,  // ✅ Edad REAL, no ageFrom
            id: newId
          });
        }

        // Si faltan más edades de las que tenemos en realAges (caso borde)
        if (missingCount > availableRealAges.length) {
          console.warn(`⚠️ Faltan ${missingCount - availableRealAges.length} edades para ${paxType}`);
        }
      } else {
        // Para ADULT: crear sin edad
        let counter = assignedOfType.length;
        for (let j = 0; j < missingCount; j++) {
          counter++;
          newAvailable.push({
            type: paxType,
            ageRange: { from: price.ageFrom, to: price.ageTo },
            age: null,
            id: `${paxType}_${counter}_${Date.now()}_${Math.random()}`
          });
        }
      }
    }
  }


  this.availablePassengers = newAvailable;
}
/**
 * Calcula el precio total de un ticket para TODOS los tipos de pasajero
 */
getTicketPriceForAllPassengers(option: any): number {
  if (!option) return 0;
  let total = 0;
  const paxPrices = this.optionsTour[0]?.paxPrices || [];

  for (let i = 0; i < paxPrices.length; i++) {
    const paxType = paxPrices[i].paxType;
    const count = this.passengerCounts[i] || 0;

    if (count > 0) {
      const priceForType = this.getPriceForPaxTypeTickets(option, paxType);
      total += priceForType * count;
    }
  }

  return total;
}

/**
 * Obtiene el precio total para un ticket (para mostrar en la lista)
 */
getTotalPriceForTicket(ticket: any): number {
  if (!ticket) return 0;

  if (ticket.isForAllPassengers) {
    return this.getTicketPriceForAllPassengers(ticket);
  }

  if (ticket.assignedPaxType) {
    return this.getPriceForPaxTypeTickets(ticket, ticket.assignedPaxType);
  }

  return this.getPriceForPaxTypeTickets(ticket, 'ADULT');
}

/**
 * Obtiene el precio base de una opción (para mostrar en el select)
 */
getBasePriceForOption(option: any): number {
  if (!option) return 0;
  return this.getPriceForPaxTypeTickets(option, 'ADULT');
}

/**
 * Obtiene el precio para un tipo específico de pasajero
 */
getPriceForPaxTypeTickets(option: any, paxType: string): number {
  if (!option || !option.paxPrices) return 0;

  const paxIndex = option.profility.findIndex((p: any) => p.paxType === paxType);
  if (paxIndex !== -1 && option.prices && option.prices[paxIndex]) {
    return option.profility[paxIndex].netPriceBooking || option.profility[paxIndex].amount || 0;
  }
  return 0;
}

/**
 * Obtiene el label del tipo de pasajero
 */
getPaxTypeLabel(paxType: string): string {
  const labels: { [key: string]: string } = {
    'ADULT': 'Adulto',
    'CHILD': 'Niño',
    'INFANT': 'Infante',
    'SENIOR': 'Mayor'
  };
  return labels[paxType] || paxType;
}

/**
 * Obtiene el placeholder para el select
 */
getPlaceHolderTickets(): string {
  if (!this._itemSelected?.availableDate?.arrivalDate) {
    return 'Selecciona una fecha del calendario';
  }

  if (!this.hourSelected) {
    return 'Selecciona un horario';
  }

  const availableOptions = this.getOptionsTickets(this.optionsTour);

  if (availableOptions.length === 1) {
    return 'Este ticket se aplicará a todos los pasajeros';
  }

  return `Seleccione hasta ${this.totalPassengers} tickets`;
}

/**
 * Alterna la visibilidad del tooltip
 */
toggleDeleteTooltip(index: number): void {
  if (this.showDeleteTooltip[index]) {
    this.showDeleteTooltip[index] = false;
  } else {
    // Cerrar otros tooltips
    this.showDeleteTooltip.forEach((_, i) => {
      this.showDeleteTooltip[i] = false;
    });
    this.showDeleteTooltip[index] = true;
  }
}

/**
 * Cierra el tooltip
 */
closeTooltip(index: number): void {
  this.showDeleteTooltip[index] = false;
}

/**
 * Verifica si hay múltiples tipos de pasajero seleccionados
 */
getPaxesTypeSelectedDiferent(): boolean {
  const countGreaterThanZero = this.passengerCounts.filter(count => count > 0).length;
  return countGreaterThanZero > 1;
}

formatDateSpanish(date: Date): string {
  if (!date) return '';
  moment.locale('es');
  // Para día abreviado: 'ddd' = lun, mar, mié...
  // Para mes abreviado: 'MMM' = ene, feb, mar...
  return moment(date).format('dddd D [de] MMM [de] YYYY');
}

}
